<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER QISMI -->
      <div class="header-row">
        <h2 class="page-title">Savdolar Ro'yxati</h2>
        <div class="header-actions">
          <input type="date" v-model="filterDate1" class="date-input" @change="fetchSales" />
          <input type="date" v-model="filterDate2" class="date-input" @change="fetchSales" />
          <select v-model="filterMasterId" class="master-select" @change="fetchSales">
            <option :value="null">Barcha ustalar</option>
            <option v-for="m in masters" :key="m.id" :value="m.id">{{ m.name }}</option>
          </select>
          <select v-model="printSplit" class="print-split-select" @change="savePrintSplit" title="Chek bo'lish rejimi">
            <option value="0">📄 Chek: Uzmasdan</option>
            <option value="10">✂️ Har 10 ta mahsulotda uzilsin</option>
            <option value="15">✂️ Har 15 ta mahsulotda uzilsin</option>
            <option value="20">✂️ Har 20 ta mahsulotda uzilsin</option>
            <option value="30">✂️ Har 30 ta mahsulotda uzilsin</option>
          </select>
          <!-- YANGI: Yangilash tugmasi (yangi savdolar bor bo'lsa badge bilan) -->
          <button class="refresh-sales-btn" @click="fetchSales()" :title="'Avto: har ' + (pollingInterval/1000) + ' sekund'">
            <b-icon icon="arrow-clockwise"></b-icon>
            <span v-if="newSalesCount > 0" class="new-badge">{{ newSalesCount }}</span>
            <span v-else class="auto-dot" title="Avto-yangilanish faol"></span>
          </button>
          <button class="add-btn" @click="$router.push('/chiqim/pos')">
            <b-icon icon="plus-circle-fill" class="mr-1"></b-icon> Yangi Savdo (POS)
          </button>
          <!-- 🔄 Mahsulot qaytarish (mijoz qarzini kamaytirish, kassaga teginmaydi) -->
          <button class="add-btn refund-add-btn" @click="openProductRefundModal()" title="Mijoz qaytargan mahsulotni qabul qilish (qarz kamayadi)">
            <b-icon icon="arrow-return-left" class="mr-1"></b-icon> Mahsulot qaytarish
          </button>
          <Top />
        </div>
      </div>

      <!-- JADVAL QISMI -->
      <div class="table-card">
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width:55px">№</th>
                <th>SANA</th>
                <th>MIJOZ</th>
                <th>USTA</th>
                <th>PAKET</th>
                <th>ORIGINAL</th>
                <th>ERKIN NARX</th>
                <th>CHEGIRMA</th>
                <th>JAMI</th>
                <th>TO'LANGAN</th>
                <th>QARZ</th>
                <th style="width:110px; text-align:center">TOIFA</th>
                <th style="width:170px; text-align:center">BARCODE</th>
                <th style="width:130px; text-align:center">AMAL</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in sales" :key="item.id" class="clickable-row" @click="openDetailModal(item)">
                <td><span class="id-badge">{{ item.id }}</span></td>

                <td class="text-dark font-bold">{{ formatDate(item.created_at) }}</td>

                <td>
                  <div class="font-bold text-dark">{{ item.kontragent ? item.kontragent.name : '-' }}</div>
                  <div class="text-muted small">{{ item.kontragent ? item.kontragent.phone_number : '' }}</div>
                </td>

                <td>
                  <span v-if="item.master">{{ item.master.name }}</span>
                  <span v-else class="text-muted small">-</span>
                </td>

                <td>
                  <span v-if="item.repair_package" class="tag blue-tag">{{ item.repair_package.name }}</span>
                  <span v-else class="text-muted small">-</span>
                </td>

                <td class="price">{{ formatMoney(getOriginalSumma(item)) }}</td>

                <td class="price orange">{{ formatMoney(getArzonSumma(item)) }}</td>

                <td class="price orange">{{ formatMoney(getDiscountSumma(item)) }}</td>

                <td class="price blue">{{ formatMoney(item.summa) }}</td>

                <td class="pay-breakdown-cell">
                  <div v-if="getPaidSumma(item) > 0" class="pay-pills">
                    <!-- Yangi: dinamik payments[] dan -->
                    <template v-if="Array.isArray(item.payments) && item.payments.length > 0">
                      <span v-for="p in item.payments" :key="p.id"
                        class="pay-pill"
                        :class="payPillClass(p.pay_type && p.pay_type.name)"
                        :title="(p.pay_type && p.pay_type.name) + ': ' + (isPayDollar(p) ? p.summa + '$' : formatMoney(p.summa))">
                        {{ payPillIcon(p.pay_type && p.pay_type.name) }}
                        {{ isPayDollar(p) ? Number(p.summa) + '$' : formatShort(p.summa) }}
                      </span>
                    </template>
                    <!-- Eski savdolar fallback -->
                    <template v-else>
                      <span v-if="Number(item.cash_summa || 0) > 0" class="pay-pill pp-naqd"
                        :title="'Naqd: ' + formatMoney(item.cash_summa)">
                        💵 {{ formatShort(item.cash_summa) }}
                      </span>
                      <span v-if="Number(item.plastic_summa || 0) > 0" class="pay-pill pp-plastic"
                        :title="'Plastik: ' + formatMoney(item.plastic_summa)">
                        💳 {{ formatShort(item.plastic_summa) }}
                      </span>
                      <span v-if="Number(item.shot_summa || 0) > 0" class="pay-pill pp-shot"
                        :title="'Shot: ' + formatMoney(item.shot_summa)">
                        📲 {{ formatShort(item.shot_summa) }}
                      </span>
                      <span v-if="Number(item.dollar_summa || 0) > 0" class="pay-pill pp-dollar"
                        :title="'Dollar: ' + item.dollar_summa + ' $'">
                        💲 {{ Number(item.dollar_summa) }}$
                      </span>
                    </template>
                  </div>
                  <span v-else class="text-muted">—</span>
                  <div class="pay-total green">{{ formatMoney(getPaidSumma(item)) }}</div>
                </td>

                <td>
                  <span :class="getDebtClass(item)">{{ formatMoney(getQarzSumma(item)) }}</span>
                </td>

                <td style="text-align:center" @click.stop>
                  <span class="cat-badge" :class="'cat-' + getSaleCategory(item)" :title="getCategoryTooltip(item)">
                    {{ getCategoryLabel(item) }}
                    <small v-if="getSalePct(item) !== 0" class="cat-pct">
                      {{ getSalePct(item) > 0 ? '-' : '+' }}{{ Math.abs(getSalePct(item)) }}%
                    </small>
                  </span>
                </td>

                <td class="barcode-cell" @click.stop>
                  <barcode
                    :value="saleBarcode(item)"
                    :options="rowBarcodeOptions"
                    tag="svg"
                  ></barcode>
                </td>

                <td>
                  <div class="actions">
                    <button class="icon-btn edit" @click.stop="editSale(item)" title="Tahrirlash">
                      <b-icon icon="pencil"></b-icon>
                    </button>
                    <button v-if="getDebt(item) > 0" class="icon-btn pay" @click.stop="openPayModal(item)" title="To'lov qilish">
                      <b-icon icon="cash-stack"></b-icon>
                    </button>
                    <button class="icon-btn refund-btn" @click.stop="openRefundModal(item)" title="Qaytarish">
                      <b-icon icon="arrow-return-left"></b-icon>
                    </button>
                    <button class="icon-btn print" @click.stop="printSaleReceipt(item)" title="Chop etish">
                      <b-icon icon="printer"></b-icon>
                    </button>
                    <!-- <button class="icon-btn del" @click.stop="openDeleteModal(item)" title="O'chirish">
                      <b-icon icon="trash"></b-icon>
                    </button> -->
                  </div>
                </td>
              </tr>

              <tr v-if="!loading && sales.length === 0">
                <td colspan="13" class="empty-row">
                  <div class="py-5 text-center">
                    <p>Ma'lumot topilmadi</p>
                  </div>
                </td>
              </tr>

              <tr v-if="loading">
                <td colspan="13" class="text-center py-5">
                  <b-spinner variant="primary"></b-spinner>
                </td>
              </tr>
            </tbody>

            <!-- JAMI QATORI -->
            <tfoot v-if="sales.length > 0">
              <tr class="total-row">
                <td colspan="5" class="text-right font-bold">JAMI:</td>
                <td class="price font-bold">{{ formatMoney(totalOriginalSumma) }}</td>
                <td class="price orange font-bold">{{ formatMoney(totalArzonSumma) }}</td>
                <td class="price orange font-bold">{{ formatMoney(totalDiscountSumma) }}</td>
                <td class="price blue font-bold">{{ formatMoney(totalSumma) }}</td>
                <td class="price green font-bold">{{ formatMoney(totalPaidSumma) }}</td>
                <td class="price red font-bold">{{ formatMoney(totalQarzSumma) }}</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

    </div>

    <!-- DETAIL MODALI -->
    <div v-if="showDetailModal && detailItem" class="modal-overlay" @click.self="closeDetailModal">
      <div class="detail-modal animate-pop">
        <div class="detail-header">
          <h3>Savdo #{{ detailItem.id }}</h3>
          <button class="close-btn" @click="closeDetailModal">&times;</button>
        </div>

        <div class="detail-info">
          <div class="info-row">
            <span class="info-label">Sana:</span>
            <span>{{ formatDate(detailItem.created_at) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Mijoz:</span>
            <span>{{ detailItem.kontragent ? detailItem.kontragent.name : '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Usta:</span>
            <span>{{ detailItem.master ? detailItem.master.name : '-' }}</span>
          </div>
        </div>

        <!-- XIZMATLAR -->
        <div v-if="detailItem.packages && detailItem.packages.length > 0" class="detail-section">
          <h4 class="section-title purple">Xizmatlar</h4>
          <table class="detail-table">
            <thead>
              <tr>
                <th>№</th>
                <th>Nomi</th>
                <th>Ish haqi (ch)</th>
                <th>Pred (ch)</th>
                <th>Ish haqi (op)</th>
                <th>Pred (op)</th>
                <th>Jami</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(pkg, idx) in detailItem.packages" :key="pkg.id">
                <td>{{ idx + 1 }}</td>
                <td>{{ pkg.name || '-' }}</td>
                <td class="text-right">{{ formatMoney(pkg.labor_price_chakana) }}</td>
                <td class="text-right">{{ formatMoney(pkg.redo_price_chakana) }}</td>
                <td class="text-right">{{ formatMoney(pkg.labor_price_optom) }}</td>
                <td class="text-right">{{ formatMoney(pkg.redo_price_optom) }}</td>
                <td class="text-right font-bold">{{ formatMoney(Number(pkg.labor_price_chakana || 0) + Number(pkg.redo_price_chakana || 0) + Number(pkg.labor_price_optom || 0) + Number(pkg.redo_price_optom || 0)) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Bitta paket (packages yo'q, lekin repair_package bor) -->
        <div v-else-if="detailItem.repair_package" class="detail-section">
          <h4 class="section-title purple">Xizmat</h4>
          <table class="detail-table">
            <thead>
              <tr>
                <th>Nomi</th>
                <th>Ish haqi (ch)</th>
                <th>Pred (ch)</th>
                <th>Ish haqi (op)</th>
                <th>Pred (op)</th>
                <th>Jami</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ detailItem.repair_package.name }}</td>
                <td class="text-right">{{ formatMoney(detailItem.labor_price_chakana) }}</td>
                <td class="text-right">{{ formatMoney(detailItem.redo_price_chakana) }}</td>
                <td class="text-right">{{ formatMoney(detailItem.labor_price_optom) }}</td>
                <td class="text-right">{{ formatMoney(detailItem.redo_price_optom) }}</td>
                <td class="text-right font-bold">{{ formatMoney(Number(detailItem.labor_price_chakana || 0) + Number(detailItem.redo_price_chakana || 0) + Number(detailItem.labor_price_optom || 0) + Number(detailItem.redo_price_optom || 0)) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- MAHSULOTLAR -->
        <div v-if="detailItem.items && detailItem.items.length > 0" class="detail-section">
          <h4 class="section-title blue">Mahsulotlar</h4>
          <table class="detail-table">
            <thead>
              <tr>
                <th>№</th>
                <th>Nomi</th>
                <th class="text-right">Narx × Soni</th>
                <th class="text-right">Summasi</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(itm, idx) in detailItem.items" :key="itm.id" :class="{ 'arzon-row': isArzon(itm) }">
                <td>{{ idx + 1 }}</td>
                <td>
                  {{ itm.product ? (itm.product.name || itm.product.extra_name) : '-' }}
                  <span v-if="Number(itm.discount_percent) > 0" class="disc-pill" :title="'Chegirma foizi'">
                    −{{ Number(itm.discount_percent) }}%
                  </span>
                </td>
                <td class="text-right">
                  <!-- Arzon sotilgan bo'lsa: ustiga chizilgan asl narxni ko'rsatish -->
                  <div v-if="isArzon(itm)" class="orig-strike">
                    {{ itm.count }} × {{ formatMoney(itm.original_price) }} UZS
                  </div>
                  <div>{{ itm.count }} × {{ formatMoney(itm.price) }}</div>
                </td>
                <td class="text-right font-bold">{{ formatMoney(itm.summa) }} UZS</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="(!detailItem.items || detailItem.items.length === 0) && !detailItem.repair_package && (!detailItem.packages || detailItem.packages.length === 0)" class="empty-detail">
          Ma'lumot topilmadi
        </div>

        <!-- TO'LOV MA'LUMOTLARI (mobile chek formati) -->
        <div class="detail-section pay-info-card">
          <h4 class="section-title">💰 To'lov ma'lumotlari</h4>

          <!-- Asl jami strikethrough — agar arzon sotilgan mahsulotlar bo'lsa -->
          <div v-if="detailOriginalSum > detailTotalSum" class="pi-row">
            <span class="pi-label">Asl jami</span>
            <span class="pi-orig-strike">{{ formatMoney(detailOriginalSum) }} UZS</span>
          </div>
          <div class="pi-row pi-jami">
            <span class="pi-label">JAMI</span>
            <span class="pi-jami-val">{{ formatMoney(detailTotalSum) }} UZS</span>
          </div>

          <div class="pi-divider"></div>

          <!-- Per-pay_type breakdown -->
          <template v-if="detailPayments.length > 0">
            <div v-for="p in detailPayments" :key="p.id" class="pi-row pi-pay">
              <span class="pi-label">
                <span class="pi-icon" :class="p.is_dollar ? 'cur-dollar' : 'cur-sum'">
                  {{ p.is_dollar ? '$' : '₸' }}
                </span>
                {{ p.pay_type_name }}
              </span>
              <span class="pi-val pi-paid">
                <template v-if="p.is_dollar">
                  ${{ formatMoney(p.summa) }}
                  <small class="pi-sum-eq" v-if="p.summa_in_sum > 0">({{ formatMoney(p.summa_in_sum) }} UZS)</small>
                </template>
                <template v-else>{{ formatMoney(p.summa) }} UZS</template>
              </span>
            </div>
          </template>
          <div v-else-if="detailPaidSumma > 0" class="pi-row pi-pay">
            <span class="pi-label">To'landi</span>
            <span class="pi-val pi-paid">{{ formatMoney(detailPaidSumma) }} UZS</span>
          </div>

          <!-- Nasiya (qarz qoldiq) -->
          <div v-if="detailDebtSumma > 0" class="pi-divider"></div>
          <div v-if="detailDebtSumma > 0" class="pi-row pi-debt">
            <span class="pi-label">Nasiya (so'mda)</span>
            <span class="pi-val pi-debt-val">{{ formatMoney(detailDebtSumma) }} UZS</span>
          </div>
          <div v-if="detailItem.qarz_dollar_summa > 0" class="pi-row pi-debt">
            <span class="pi-label">Nasiya ($)</span>
            <span class="pi-val pi-debt-val">${{ formatMoney(detailItem.qarz_dollar_summa) }}</span>
          </div>
          <div v-if="detailItem.debt_due_date > 0" class="pi-row pi-due">
            <span class="pi-label">📅 To'lov muddati</span>
            <span class="pi-val">{{ formatDueDate(detailItem.debt_due_date) }}</span>
          </div>
          <div v-if="detailItem.debt_comment" class="pi-row pi-comment">
            <span class="pi-label">💬 Izoh</span>
            <span class="pi-val muted">{{ detailItem.debt_comment }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- O'CHIRISH MODALI -->
    <div v-if="showDeleteModal" class="modal-overlay" @click.self="closeDeleteModal">
      <div class="modal-box animate-pop">
        <div class="warning-icon">!</div>
        <h3>O'chirishni tasdiqlaysizmi?</h3>
        <p v-if="selectedItem" class="text-secondary mt-2">
          <b>#{{ selectedItem.id }}</b> savdo tizimdan o'chiriladi.
        </p>
        <div class="modal-btns">
          <button class="m-btn cancel" @click="closeDeleteModal">YO'Q</button>
          <button class="m-btn confirm" @click="deleteItem">HA, O'CHIRILSIN</button>
        </div>
      </div>
    </div>

    <!-- CHEK REJIMI TANLASH — savdoda qaytarish bo'lsa chiqadi -->
    <div v-if="printChoice.show" class="modal-overlay" @click.self="printChoice.show = false">
      <div class="modal-box animate-pop">
        <h3>🖨 Qaysi chek chiqarilsin?</h3>
        <p class="text-secondary mt-2">
          <b>#{{ printChoice.item && printChoice.item.id }}</b> savdoda
          <b>{{ printChoice.refunds.length }}</b> ta qaytarish bor
          (jami {{ formatMoney(printChoiceRefundSum) }} UZS).
        </p>
        <div class="print-choice-btns">
          <button class="m-btn choice" @click="runPrintChoice('sale')">
            🧾 Savdo cheki<small>Faqat qolgan mahsulotlar</small>
          </button>
          <button class="m-btn choice primary" @click="runPrintChoice('both')">
            🧾+🔄 Savdo + qaytarilgan<small>Bitta chekda, yakuniy hisob bilan</small>
          </button>
          <button class="m-btn choice" @click="runPrintChoice('refund')">
            🔄 Faqat qaytarilgan<small>Alohida qaytarish cheki</small>
          </button>
        </div>
        <div class="modal-btns">
          <button class="m-btn cancel" @click="printChoice.show = false">BEKOR</button>
        </div>
      </div>
    </div>

    <!-- TO'LOV MODALI -->
    <div v-if="showPayModal && payItem" class="modal-overlay" @click.self="closePayModal">
      <div class="pay-modal animate-pop">
        <div class="detail-header">
          <h3>Qarz to'lash — Savdo #{{ payItem.id }}</h3>
          <button class="close-btn" @click="closePayModal">&times;</button>
        </div>

        <div class="pay-info">
          <div class="pay-info-row">
            <span class="info-label">Mijoz:</span>
            <span class="font-bold">{{ payItem.kontragent ? payItem.kontragent.name : '-' }}</span>
          </div>
          <div class="pay-info-row">
            <span class="info-label">Savdo summasi:</span>
            <span class="font-bold blue">{{ formatMoney(payItem.summa) }}</span>
          </div>
          <div class="pay-info-row">
            <span class="info-label">To'langan:</span>
            <span class="font-bold green">{{ formatMoney(getPaid(payItem)) }}</span>
          </div>
          <div class="pay-info-row">
            <span class="info-label">Qarz qoldiq:</span>
            <span class="font-bold red">{{ formatMoney(getDebt(payItem)) }}</span>
          </div>
        </div>

        <div class="pay-form">
          <div class="pay-field">
            <label>To'lov turi</label>
            <select v-model.number="payForm.pay_type_id" class="pay-input">
              <option v-for="pt in payTypes" :key="pt.id" :value="pt.id">{{ pt.name }}</option>
            </select>
          </div>
          <div class="pay-field">
            <label>Summa</label>
            <div style="display:flex;gap:6px">
              <input type="number" v-model.number="payForm.paid_summa" min="0" class="pay-input" placeholder="0" style="flex:1" />
              <button class="m-btn" style="white-space:nowrap;padding:6px 10px;font-size:12px"
                @click="payForm.paid_summa = getDebt(payItem)">To'liq</button>
            </div>
          </div>
          <div class="pay-field">
            <label>Izoh</label>
            <input type="text" v-model="payForm.comment" class="pay-input" placeholder="Izoh..." />
          </div>
          <div class="pay-total-row">
            <span>To'lanadigan summa:</span>
            <span class="font-bold blue">{{ formatMoney(payFormTotal) }}</span>
          </div>
        </div>

        <div class="pay-actions">
          <button class="m-btn cancel" @click="closePayModal">BEKOR</button>
          <button class="m-btn pay-confirm" @click="submitPayment" :disabled="payFormTotal <= 0 || payLoading">
            {{ payLoading ? 'Saqlanmoqda...' : 'TO\'LASH' }}
          </button>
        </div>
      </div>
    </div>

    <!-- QAYTARISH (REFUND) MODALI -->
    <div v-if="showRefundModal && refundItem" class="modal-overlay" @click.self="closeRefundModal">
      <div class="refund-modal animate-pop">
        <div class="detail-header">
          <h3>Qaytarish — Savdo #{{ refundItem.id }}</h3>
          <button class="close-btn" @click="closeRefundModal">&times;</button>
        </div>

        <!-- XIZMATLAR -->
        <div v-if="refundServiceList.length > 0" class="refund-section">
          <h4 class="section-title purple">Xizmatlar</h4>
          <div v-for="(srv, idx) in refundServiceList" :key="'srv-' + idx" class="refund-check-row">
            <label class="refund-checkbox">
              <input type="checkbox" v-model="srv.selected" />
              <span class="refund-item-name">{{ srv.name }}</span>
              <span class="refund-item-price">{{ formatMoney(srv.total) }}</span>
            </label>
          </div>
        </div>

        <!-- MAHSULOTLAR -->
        <div v-if="refundProductList.length > 0" class="refund-section">
          <h4 class="section-title blue">Mahsulotlar</h4>
          <table class="detail-table">
            <thead>
              <tr>
                <th style="width:36px"></th>
                <th>Nomi</th>
                <th style="width:80px">Soni</th>
                <th>Narxi</th>
                <th>Summa</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(prod, idx) in refundProductList" :key="'prod-' + idx">
                <td><input type="checkbox" v-model="prod.selected" /></td>
                <td>{{ prod.name }}</td>
                <td>
                  <input type="number" v-model.number="prod.refund_count" :max="prod.max_count" min="0"
                    class="refund-count-input" :disabled="!prod.selected" @input="recalcProductSumma(prod)" />
                </td>
                <td class="text-right">{{ formatMoney(prod.price) }}</td>
                <td class="text-right font-bold">{{ formatMoney(prod.refund_summa) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- QAYTARISH SUMMASI -->
        <div class="refund-summary">
          <div class="pay-info-row">
            <span class="info-label">Xizmat qaytarish:</span>
            <span class="font-bold purple">{{ formatMoney(refundServiceTotal) }}</span>
          </div>
          <div class="pay-info-row">
            <span class="info-label">Mahsulot qaytarish:</span>
            <span class="font-bold blue">{{ formatMoney(refundProductTotal) }}</span>
          </div>
          <div class="pay-info-row" style="border-top:2px solid #e2e8f0;padding-top:8px;margin-top:6px">
            <span class="font-bold">JAMI QAYTARISH:</span>
            <span class="font-bold red">{{ formatMoney(refundGrandTotal) }}</span>
          </div>
        </div>

        <!-- QAYTARISH REJIMI: QARZDAN / KASSADAN -->
        <div v-if="refundGrandTotal > 0" class="pay-form pr-paymode" style="background:#fff7ed;border-radius:8px;padding:12px;margin-top:12px">
          <div class="pr-paymode-title" style="margin-bottom:8px">Qaytarish rejimi:</div>
          <div class="pr-paymode-grid">
            <!-- Mijoz bor: qarzdan ushlash mumkin -->
            <label v-if="refundItemHasKontragent" class="pr-radio-card" :class="{ active: refundForm.payMode === 'debt' }">
              <input type="radio" v-model="refundForm.payMode" value="debt" />
              <div class="pr-radio-body">
                <div class="pr-radio-title">💰 Qarzdan kamaytirish</div>
                <div class="pr-radio-desc">
                  Mijoz qarzi qaytarish summasiga kamayadi. Kassaga teginmaydi.
                </div>
              </div>
            </label>
            <label class="pr-radio-card" :class="{ active: refundForm.payMode === 'cash' }">
              <input type="radio" v-model="refundForm.payMode" value="cash" />
              <div class="pr-radio-body">
                <div class="pr-radio-title">💵 Pul qaytarish (kassadan)</div>
                <div class="pr-radio-desc">
                  {{ refundItemHasKontragent ? 'Mijoz qarzi o\'zgarmaydi, kassadan pul qaytariladi.' : 'Kassadan pul qaytariladi.' }}
                </div>
              </div>
            </label>
          </div>

          <!-- CASH REJIM: DINAMIK TO'LOV TURLARI -->
          <div v-if="refundForm.payMode === 'cash'" class="pr-paytypes" style="margin-top:10px">
            <div class="pr-paytypes-title" style="margin-bottom:6px">
              To'lov turlari (jami: <b>{{ formatMoney(refundGrandTotal) }} UZS</b>)
              <button type="button" class="m-btn" style="margin-left:8px;padding:4px 8px;font-size:11px" @click="refundDefaultFillCash" title="Hammasini birinchi so'm turiga to'ldirish">✨ Auto</button>
            </div>
            <div v-for="pt in payTypes" :key="pt.id" class="pr-paytype-row" style="display:flex;align-items:center;gap:6px;margin-bottom:6px">
              <label class="pr-paytype-label" style="min-width:130px;font-size:13px">
                {{ isDollarPayType(pt) ? '💲' : '💵' }} {{ pt.name }} {{ isDollarPayType(pt) ? '(USD)' : '(UZS)' }}
              </label>
              <input type="number" v-model.number="refundForm.payAmounts[pt.id]" min="0" step="any"
                     class="pay-input pr-paytype-input" placeholder="0" style="flex:1" />
              <button type="button" class="m-btn" style="padding:4px 8px;font-size:11px"
                      @click="refundFillPayTypeRemaining(pt)" title="Qolgan summani to'ldirish">⚡</button>
              <span v-if="isDollarPayType(pt)" class="pr-dollar-eq" style="font-size:11px;color:#64748b;min-width:120px;text-align:right">
                ≈ {{ formatMoney(Number(refundForm.payAmounts[pt.id] || 0) * refundForm.dollarRate) }} UZS
              </span>
            </div>
            <div class="pr-paytypes-total" style="margin-top:6px;font-size:13px;display:flex;justify-content:space-between">
              <span>Kiritildi:</span>
              <b>{{ formatMoney(refundPayTypesEnteredTotal) }} UZS</b>
            </div>
            <div class="pr-paytypes-diff" :class="refundPayTypesBalanceClass"
                 style="margin-top:4px;font-size:13px;display:flex;justify-content:space-between"
                 :style="Math.abs(refundPayTypesDiff) < 1 ? 'color:#15803d' : 'color:#b91c1c'">
              <span>Farq:</span>
              <b>{{ refundPayTypesDiff > 0 ? '+' : '' }}{{ formatMoney(refundPayTypesDiff) }} UZS</b>
            </div>
          </div>

          <div class="pay-field" style="margin-top:10px">
            <label>Izoh</label>
            <input type="text" v-model="refundForm.comment" class="pay-input" placeholder="Qaytarish sababi..." />
          </div>
        </div>

        <div class="pay-actions">
          <button class="m-btn cancel" @click="closeRefundModal">BEKOR</button>
          <button class="m-btn refund-confirm" @click="submitRefund" :disabled="!canSubmitRefund">
            {{ refundLoading ? 'Saqlanmoqda...' : 'QAYTARISH' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ═══════════════ 🔄 MAHSULOT QAYTARISH MODAL (mustaqil — savdoga bog'liq emas) ═══════════════ -->
    <div v-if="prefund.show" class="pr-overlay" @click.self="prefund.show = false">
      <div class="pr-modal">
        <div class="pr-head">
          <h3 class="pr-title">🔄 Mahsulot qaytarish</h3>
          <button class="pr-close" @click="prefund.show = false">&times;</button>
        </div>

        <div class="pr-body">
          <!-- Mijoz tanlash — IXTIYORIY (v-select, kabira ro'yxat) -->
          <div class="pr-field">
            <label class="pr-label">
              Mijoz <span class="pr-opt-tag">(ixtiyoriy)</span>
            </label>
            <v-select
              :options="prefund.kontragentList"
              v-model="prefund.selectedKontragent"
              label="name"
              :loading="prefund.kontragentLoading"
              :clearable="true"
              placeholder="Mijoz tanlang yoki yozib qidiring..."
              class="pr-vselect"
              @search="onKontragentTypeSearch"
              @input="onKontragentSelected"
            >
              <template #option="{ name, phone_number, balance }">
                <div class="pr-opt-row">
                  <div>
                    <b>{{ name }}</b>
                    <span class="pr-opt-phone">{{ phone_number || '—' }}</span>
                  </div>
                  <div v-if="Number(balance || 0) > 0" class="pr-opt-debt debt-red">
                    Qarz: {{ formatMoney(balance) }} UZS
                  </div>
                  <div v-else-if="Number(balance || 0) < 0" class="pr-opt-debt debt-green">
                    Haqdor: {{ formatMoney(Math.abs(balance)) }} UZS
                  </div>
                  <div v-else class="pr-opt-debt debt-gray">Qarz yo'q</div>
                </div>
              </template>
              <template #selected-option="{ name }">
                <b>{{ name }}</b>
              </template>
              <template v-slot:no-options>
                Mijoz topilmadi. Ism yoki telefonni yozing.
              </template>
            </v-select>
            <div v-if="prefund.selectedKontragent" class="pr-debt-line">
              Joriy qarzi: <b>{{ formatMoney(prefund.kontragentDebt) }} so'm</b>
            </div>
            <div v-else class="pr-debt-line muted">
              Mijoz tanlanmasa — qaytarish faqat omborga ta'sir qiladi
            </div>
          </div>

          <!-- Mijoz sotib olgan mahsulotlar — ro'yxatdan istalgancha tanlash -->
          <div v-if="prefund.selectedKontragent" class="pr-purchased">
            <div class="pr-purchased-head">
              <span>Sotib olgan mahsulotlar</span>
              <span v-if="prefund.purchasedLoading" class="pr-purchased-loading">yuklanmoqda...</span>
              <span v-else class="pr-purchased-count">{{ prefund.purchasedProducts.length }} ta</span>
            </div>
            <div v-if="!prefund.purchasedLoading && prefund.purchasedProducts.length === 0" class="pr-purchased-empty">
              Saqlangan savdo topilmadi. Pastdan qidirib qo'shing.
            </div>
            <div v-else-if="prefund.purchasedProducts.length > 0" class="pr-purchased-list">
              <div v-for="(p, i) in prefund.purchasedProducts" :key="'pur-' + i"
                   class="pr-purchased-row" :class="{ picked: purchasedSelectedQty(p) > 0 }">
                <div class="pr-purchased-info">
                  <span class="pr-purchased-name">{{ p.name }}</span>
                  <span class="pr-purchased-meta">
                    Olgan: {{ p.bought }}<template v-if="p.refunded > 0"> · qaytgan: {{ p.refunded }}</template>
                    · qoldi: <b>{{ p.count }}</b> · {{ formatMoney(p.price) }} so'm
                  </span>
                </div>
                <div class="pr-stepper">
                  <button type="button" class="pr-step-btn" :disabled="purchasedSelectedQty(p) <= 0" @click="decPurchased(p)">−</button>
                  <span class="pr-step-val">{{ purchasedSelectedQty(p) }}</span>
                  <button type="button" class="pr-step-btn" @click="incPurchased(p)">+</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Boshqa mahsulot qo'shish — savdoda yo'q / eski xaridlar uchun -->
          <div class="pr-add-other-hint">Boshqa mahsulot qo'shish</div>

          <!-- Mahsulot tanlash — v-select (async server search) + Scanner input -->
          <div class="pr-row-2">
            <div class="pr-field" style="flex:2">
              <label class="pr-label">Mahsulot qidirish</label>
              <v-select
                :options="prefund.productResults"
                v-model="prefund.productPicker"
                label="extra_name"
                :loading="prefund.productLoading"
                :clearable="false"
                :filterable="false"
                placeholder="sam 25 / YDK-742 / nomi..."
                class="pr-vselect"
                @search="onProductTypeSearch"
                @input="onProductSelected"
              >
                <template #option="{ extra_name, balance, price_register, code }">
                  <div class="pr-opt-row">
                    <div style="flex:1">
                      <b>{{ extra_name }}</b>
                      <span v-if="code" class="pr-code">{{ code }}</span>
                    </div>
                    <div class="pr-opt-info">
                      Qold: <b>{{ balance || 0 }}</b> ·
                      <b>{{ formatMoney((price_register && price_register.chakana_price) || 0) }} UZS</b>
                    </div>
                  </div>
                </template>
                <template v-slot:no-options="{ search }">
                  <span v-if="!search">Yozib boshlang (2+ harf)</span>
                  <span v-else-if="prefund.productLoading">Qidirilmoqda...</span>
                  <span v-else>"{{ search }}" topilmadi</span>
                </template>
              </v-select>
            </div>
            <div class="pr-field" style="flex:1">
              <label class="pr-label">Shtrix skaner</label>
              <input
                ref="scannerInput"
                v-model="prefund.scannerCode"
                type="text"
                class="pr-input pr-scanner-input"
                placeholder="Skanyer barcode..."
                @keyup.enter="onBarcodeScanned"
              />
            </div>
          </div>

          <!-- Tanlangan mahsulotlar jadvali -->
          <div v-if="prefund.items.length === 0" class="pr-empty">
            Hali mahsulot qo'shilmadi. Yuqoridan qidirib qo'shing.
          </div>
          <table v-else class="pr-table">
            <thead>
              <tr>
                <th style="width:40px">№</th>
                <th>Mahsulot</th>
                <th style="width:90px">Soni</th>
                <th style="width:130px">Narx (UZS)</th>
                <th style="width:140px">Summa</th>
                <th style="width:40px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(it, i) in prefund.items" :key="'pf-row-' + i">
                <td>{{ i + 1 }}</td>
                <td>
                  <div class="pr-pname">{{ it.name }}</div>
                  <small v-if="it.maxCount > 0" class="pr-maxhint">maks: {{ it.maxCount }} ta</small>
                </td>
                <td>
                  <input v-model.number="it.count" type="number" min="0.01" step="any"
                         :max="it.maxCount > 0 ? it.maxCount : null" class="pr-qty"
                         @input="clampItemCount(it)" />
                </td>
                <td><input v-model.number="it.price" type="number" min="0" step="any" class="pr-qty" /></td>
                <td class="pr-summa">{{ formatMoney((it.count || 0) * (it.price || 0)) }} UZS</td>
                <td>
                  <button class="pr-btn-x" @click="prefund.items.splice(i, 1)" title="O'chirish">
                    <b-icon icon="x-lg"></b-icon>
                  </button>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="4" class="pr-jami-label">JAMI:</td>
                <td colspan="2" class="pr-jami-val">{{ formatMoney(prefundTotal) }} UZS</td>
              </tr>
            </tfoot>
          </table>

          <!-- To'lov rejimi (faqat mijoz tanlangan + mahsulot bor bo'lsa) -->
          <div v-if="prefund.selectedKontragent && prefundTotal > 0" class="pr-paymode">
            <label class="pr-label">Qaytarish rejimi</label>
            <div class="pr-paymode-grid">
              <label class="pr-radio-card" :class="{ active: prefund.payMode === 'debt' }">
                <input type="radio" v-model="prefund.payMode" value="debt" />
                <div class="pr-radio-body">
                  <div class="pr-radio-title">Qarzdan ushlash</div>
                  <div class="pr-radio-desc">Mijoz qarzi kamayadi</div>
                </div>
              </label>
              <label class="pr-radio-card" :class="{ active: prefund.payMode === 'cash' }">
                <input type="radio" v-model="prefund.payMode" value="cash" />
                <div class="pr-radio-body">
                  <div class="pr-radio-title">Pul qaytarish</div>
                  <div class="pr-radio-desc">Kassadan pul chiqadi</div>
                </div>
              </label>
            </div>

            <!-- To'lov turlari (cash mode) — DINAMIK pay_type -->
            <div v-if="prefund.payMode === 'cash'" class="pr-paytypes">
              <div class="pr-paytypes-title">
                To'lov turlari (jami: <b>{{ formatMoney(prefundTotal) }} so'm</b>)
              </div>
              <div v-for="pt in prefund.payTypes" :key="pt.id" class="pr-paytype-row">
                <label class="pr-paytype-label">{{ isDollarPayType(pt) ? '💲' : '💵' }} {{ pt.name }} {{ isDollarPayType(pt) ? '(USD)' : '(UZS)' }}</label>
                <input type="number" v-model.number="prefund.payAmounts[pt.id]" min="0" step="any" class="pr-input pr-paytype-input" placeholder="0" />
                <span v-if="isDollarPayType(pt)" class="pr-dollar-eq">≈ {{ formatMoney(Number(prefund.payAmounts[pt.id] || 0) * prefund.dollarRate) }} UZS</span>
                <button v-else class="pr-quick-fill" @click="fillPayTypeRemaining(pt)" title="Qolgan summa">⚡</button>
              </div>
              <div class="pr-paytypes-summary" :class="paytypesBalanceClass">
                <div class="pr-pts-row">
                  <span>Kiritildi:</span>
                  <b>{{ formatMoney(payTypesEnteredTotal) }} UZS</b>
                </div>
                <div class="pr-pts-row">
                  <span>Kerakli:</span>
                  <b>{{ formatMoney(prefundTotal) }} UZS</b>
                </div>
                <div class="pr-pts-row pr-pts-diff">
                  <span>Farq:</span>
                  <b>{{ payTypesDiff > 0 ? '+' : '' }}{{ formatMoney(payTypesDiff) }} UZS</b>
                </div>
              </div>
            </div>
          </div>

          <!-- Mijozsiz: ixtiyoriy pul qaytarish (kassadan) -->
          <div v-if="!prefund.selectedKontragent && prefundTotal > 0" class="pr-paymode">
            <label class="pr-restock-toggle">
              <input type="checkbox" v-model="prefund.cashRefund" />
              <span class="pr-restock-text">
                <b>Pul qaytarilsinmi (kassadan)?</b>
                <small>Belgilanmasa faqat ombor hisobi o'zgaradi</small>
              </span>
            </label>
            <div v-if="prefund.cashRefund" class="pr-paytypes">
              <div class="pr-paytypes-title">
                To'lov turlari (jami: <b>{{ formatMoney(prefundTotal) }} so'm</b>)
              </div>
              <div v-for="pt in prefund.payTypes" :key="pt.id" class="pr-paytype-row">
                <label class="pr-paytype-label">{{ isDollarPayType(pt) ? '💲' : '💵' }} {{ pt.name }} {{ isDollarPayType(pt) ? '(USD)' : '(UZS)' }}</label>
                <input type="number" v-model.number="prefund.payAmounts[pt.id]" min="0" step="any" class="pr-input pr-paytype-input" placeholder="0" />
                <span v-if="isDollarPayType(pt)" class="pr-dollar-eq">≈ {{ formatMoney(Number(prefund.payAmounts[pt.id] || 0) * prefund.dollarRate) }} UZS</span>
                <button v-else class="pr-quick-fill" @click="fillPayTypeRemaining(pt)" title="Qolgan summa">⚡</button>
              </div>
            </div>
          </div>

          <!-- Mahsulot omborga qaytsinmi? -->
          <div v-if="prefundTotal > 0" class="pr-restock">
            <label class="pr-restock-toggle">
              <input type="checkbox" v-model="prefund.restock" />
              <span class="pr-restock-text">
                <b>Mahsulot omborga qaytsin</b>
                <small v-if="prefund.restock">Ombor qoldig'i oshadi</small>
                <small v-else>Yaroqsiz — ombor o'zgarmaydi, faqat pul/qarz qaytadi</small>
              </span>
            </label>
          </div>

          <!-- Izoh -->
          <div class="pr-field">
            <label class="pr-label">Izoh (ixtiyoriy)</label>
            <input v-model="prefund.comment" type="text" class="pr-input" placeholder="Qaytarish sababi..." />
          </div>
        </div>

        <div class="pr-foot">
          <button class="pr-btn-cancel" @click="prefund.show = false">Bekor</button>
          <button class="pr-btn-save"
            :disabled="!canSubmitPrefund || prefund.loading"
            @click="submitProductRefund()">
            <b-icon icon="check-circle-fill"></b-icon>
            {{ prefund.loading ? 'Saqlanmoqda...' : `Qaytarishni saqlash (${formatMoney(prefundTotal)} UZS)` }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Top from '../Layout/Top.vue';
import VueBarcode from 'vue-barcode';
import JsBarcode from 'jsbarcode';
import {
  receiptHeaderHtml, itemBlockHtml, openReceiptWindow,
  formatMoney as rcpMoney, formatDateTime as rcpDate, unitShort as rcpUnit,
} from '@/utils/receipt';

export default {
  name: 'ChiqimIndex',
  components: { Top, barcode: VueBarcode },
  data() {
    const today = new Date();
    const y = today.getFullYear();
    const m = String(today.getMonth() + 1).padStart(2, '0');
    const d = String(today.getDate()).padStart(2, '0');
    const todayStr = `${y}-${m}-${d}`;
    const monthStart = `${y}-${m}-01`;
    return {
      loading: false,
      showDeleteModal: false,
      showDetailModal: false,
      showPayModal: false,
      showRefundModal: false,
      payLoading: false,
      refundLoading: false,
      selectedItem: null,
      detailItem: null,
      payItem: null,
      refundItem: null,
      refundProductList: [],
      refundServiceList: [],
      // Savdo refundi: 'debt' = qarzdan ushlash (kassaga teginmaydi), 'cash' = kassadan pul qaytarish
      refundForm: {
        payMode: 'debt',
        payAmounts: {},          // { [pay_type_id]: summa } — cash rejimida
        dollarRate: 12500,
        comment: '',
      },
      payForm: { pay_type_id: 1, paid_summa: 0, comment: '' },
      payTypes: [],
      sales: [],
      masters: [],
      // Chek bo'lish rejimi: 0 = uzmasdan, N = har N ta mahsulotdan keyin uzish
      printSplit: parseInt(localStorage.getItem('chiqim_print_split') || '0') || 0,
      // Chek rejimini tanlash modali (savdoda qaytarish bo'lganda)
      printChoice: { show: false, item: null, refunds: [] },
      // Auto-polling: oxirgi savdo ID + interval timer
      pollingTimer: null,
      pollingInterval: 20000, // 20 sekund (real-timega yaqin, lekin trafik tejaydi)
      lastKnownSaleId: 0,
      newSalesCount: 0,       // hali ko'rilmagan yangi savdolar soni
      filterDate1: monthStart,
      filterDate2: todayStr,
      filterMasterId: null,
      skladSettings: { firmName: '', phone: '', checkWord: '', logoUrl: '' },

      // 🔄 Mahsulot qaytarish modali
      prefund: {
        show: false,
        loading: false,
        // Mijoz (v-select)
        kontragentList: [],
        kontragentLoading: false,
        kontragentSearch: '',
        kontragentSearchTimer: null,
        selectedKontragent: null,
        kontragentDebt: 0,
        // Mahsulot (v-select async)
        productResults: [],
        productLoading: false,
        productPicker: null,
        productSearchTimer: null,
        // Mijoz sotib olgan mahsulotlar (kontragent tanlanganda yuklanadi)
        purchasedProducts: [],   // [{ product_id, name, price, count }]
        purchasedLoading: false,
        // Scanner
        scannerCode: '',
        // To'lov rejimi: 'debt' = qarzdan ushlash, 'cash' = kassadan to'lov turlari bo'yicha qaytarish
        payMode: 'debt',
        // 'cash' rejimida — DINAMIK to'lov turlari (pay_type_id bo'yicha)
        payTypes: [],        // [{id, name}] — /pay-type'dan
        payAmounts: {},      // { [pay_type_id]: summa }
        dollarRate: 12500,  // joriy kurs (cash dollar uchun)
        // Tanlanganlar jadvali
        items: [],   // [{ id, name, count, price }]
        comment: '',
        // Mahsulot omborga qaytsinmi? true=qaytadi (default), false=yaroqsiz (axlat/firmaga)
        restock: true,
        // Mijozsiz holatda: pul ham qaytarilsinmi (kassadan)?
        cashRefund: false,
      },
    };
  },
  watch: {
    // Cash rejimi tanlanganda yoki summa o'zgarganda — agar hech narsa kiritilmagan bo'lsa,
    // hammasini naqdga qo'yamiz (eng keng tarqalgan holat)
    'prefund.payMode'(newMode) {
      if (newMode === 'cash' && this.payTypesEnteredTotal === 0) {
        this.defaultFillCash();
      }
    },
    prefundTotal() {
      if (this.prefund.payMode === 'cash'
          && Math.abs(this.payTypesEnteredTotal - 0) < 1) {
        this.defaultFillCash();
      }
    },
    // Savdo refundi: cash rejimi tanlansa va hech narsa kiritilmagan bo'lsa — auto fill
    'refundForm.payMode'(newMode) {
      if (newMode === 'cash' && this.refundPayTypesEnteredTotal === 0) {
        this.refundDefaultFillCash();
      }
    },
    // Refund summasi o'zgarsa (mahsulot/xizmat checkbox), cash rejimida bo'sh bo'lsa avto-to'ldirish
    refundGrandTotal() {
      if (this.showRefundModal && this.refundForm.payMode === 'cash'
          && this.refundPayTypesEnteredTotal === 0) {
        this.refundDefaultFillCash();
      }
    },
  },
  computed: {
    // Chek tanlash modalidagi qaytarishlar jami summasi
    printChoiceRefundSum() {
      return (this.printChoice.refunds || []).reduce((s, r) => s + Number(r.summa || 0), 0);
    },
    totalOriginalSumma()  { return this.sales.reduce((s, i) => s + this.getOriginalSumma(i),  0); },
    totalArzonSumma()     { return this.sales.reduce((s, i) => s + this.getArzonSumma(i),     0); },
    totalDiscountSumma()  { return this.sales.reduce((s, i) => s + this.getDiscountSumma(i),  0); },
    totalSumma()          { return this.sales.reduce((s, i) => s + Number(i.summa || 0),       0); },
    totalPaidSumma()      { return this.sales.reduce((s, i) => s + this.getPaidSumma(i),      0); },
    totalQarzSumma()      { return this.sales.reduce((s, i) => s + this.getQarzSumma(i),      0); },
    payFormTotal() {
      return Number(this.payForm.paid_summa || 0);
    },
    refundServiceTotal() {
      return this.refundServiceList.filter(s => s.selected).reduce((sum, s) => sum + s.total, 0);
    },
    refundProductTotal() {
      return this.refundProductList.filter(p => p.selected).reduce((sum, p) => sum + p.refund_summa, 0);
    },
    refundGrandTotal() {
      return this.refundServiceTotal + this.refundProductTotal;
    },
    // Refund — kiritilgan to'lov turlarining so'mdagi jami (dollar × kurs)
    refundPayTypesEnteredTotal() {
      return (this.payTypes || []).reduce((sum, pt) => {
        const amt = Number(this.refundForm.payAmounts[pt.id] || 0);
        return sum + (this.isDollarPayType(pt) ? amt * Number(this.refundForm.dollarRate || 0) : amt);
      }, 0);
    },
    refundPayTypesDiff() {
      return this.refundPayTypesEnteredTotal - this.refundGrandTotal;
    },
    refundPayTypesBalanceClass() {
      const diff = this.refundPayTypesDiff;
      if (Math.abs(diff) < 1) return 'ok';
      if (diff > 0) return 'over';
      return 'under';
    },
    refundPaymentTotal() {
      return this.refundForm.payMode === 'cash' ? this.refundPayTypesEnteredTotal : 0;
    },
    refundItemHasKontragent() {
      return !!(this.refundItem && this.refundItem.kontragent_id);
    },
    canSubmitRefund() {
      if (this.refundGrandTotal <= 0 || this.refundLoading) return false;
      if (this.refundForm.payMode === 'cash') {
        return Math.abs(this.refundPayTypesDiff) < 1;
      }
      return true;
    },

    // 🔄 Mahsulot qaytarish
    prefundTotal() {
      return this.prefund.items.reduce((s, it) => s + (Number(it.count || 0) * Number(it.price || 0)), 0);
    },
    // Mijoz IXTIYORIY — yo'q bo'lsa faqat omborga qaytadi, qarzga teginmaydi
    canSubmitPrefund() {
      const baseOk = this.prefund.items.length > 0
          && this.prefund.items.every(it => Number(it.count || 0) > 0 && Number(it.price || 0) > 0)
          && this.prefundTotal > 0;
      if (!baseOk) return false;
      // Cash mode tanlangan bo'lsa — kiritilgan jami to'g'ri bo'lishi kerak (±1 so'm xatosi qabul qilinadi)
      if (this.prefund.selectedKontragent && this.prefund.payMode === 'cash') {
        return Math.abs(this.payTypesDiff) < 1;
      }
      return true;
    },

    // Cash rejimi: 3 ta to'lov turi jami so'mda
    payTypesEnteredTotal() {
      return (this.prefund.payTypes || []).reduce((sum, pt) => {
        const amt = Number(this.prefund.payAmounts[pt.id] || 0);
        return sum + (this.isDollarPayType(pt) ? amt * Number(this.prefund.dollarRate || 0) : amt);
      }, 0);
    },
    payTypesDiff() {
      return this.payTypesEnteredTotal - this.prefundTotal;
    },
    paytypesBalanceClass() {
      const diff = this.payTypesDiff;
      if (Math.abs(diff) < 1) return 'ok';
      if (diff > 0) return 'over';
      return 'under';
    },
    // Savdolar ro'yxatidagi barcode ustuni uchun ixcham sozlama.
    rowBarcodeOptions() {
      return {
        format: 'CODE128',
        displayValue: true,
        fontSize: 11,
        height: 30,
        width: 1.1,
        margin: 0,
        textMargin: 1,
      };
    },

    // ============ DETAIL MODAL — to'lov ma'lumotlari ============
    detailItemSafe() { return this.detailItem || {}; },
    detailTotalSum() { return Number((this.detailItem || {}).summa || 0); },
    detailOriginalSum() {
      // Asl jami: barcha itemlarning asl narx × soni + xizmatlar
      const items = (this.detailItem && this.detailItem.items) || [];
      const productOrig = items.reduce((s, it) => {
        const orig = Number(it.original_price || 0);
        const price = Number(it.price || 0);
        // Faqat arzon sotilgan bo'lsa asl narxni qo'shamiz, aks holda sotilgan narx
        const base = orig > price ? orig : price;
        return s + base * Number(it.count || 0);
      }, 0);
      const svc = Number((this.detailItem || {}).labor_price_chakana || 0)
                + Number((this.detailItem || {}).redo_price_chakana || 0)
                + Number((this.detailItem || {}).labor_price_optom || 0)
                + Number((this.detailItem || {}).redo_price_optom || 0);
      return productOrig + svc;
    },
    detailPayments() {
      const di = this.detailItem;
      if (!di || !Array.isArray(di.payments)) return [];
      const dollarById = (id, name) => {
        if (parseInt(id) === 3) return true;
        const n = String(name || '').toLowerCase();
        return n.includes('dollar') || n.includes('usd') || n.includes('$') || n.startsWith('доллар');
      };
      return di.payments
        .filter(p => Number(p.summa || 0) > 0)
        .map(p => {
          const ptName = (p.pay_type && p.pay_type.name) || p.pay_type_name || ("To'lov #" + p.pay_type_id);
          return {
            id: p.id,
            pay_type_id: p.pay_type_id,
            pay_type_name: ptName,
            summa: Number(p.summa || 0),
            summa_in_sum: Number(p.summa_in_sum || 0),
            is_dollar: dollarById(p.pay_type_id, ptName),
          };
        });
    },
    detailPaidSumma() { return this.getPaidSumma(this.detailItem || {}); },
    detailDebtSumma() {
      return Math.max(0, this.detailTotalSum - this.detailPaidSumma);
    },
  },
  mounted() {
    this.fetchSales();
    this.fetchMasters();
    this.fetchSkladSettings();
    this.fetchPayTypes();
    this.startAutoPolling();
    document.addEventListener('visibilitychange', this.onVisibilityChange);
  },
  beforeDestroy() {
    this.stopAutoPolling();
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  },
  methods: {
    savePrintSplit() {
      localStorage.setItem('chiqim_print_split', String(this.printSplit || 0));
    },

    /* ═══════════════ 🔄 MAHSULOT QAYTARISH MODAL ═══════════════ */
    async openProductRefundModal() {
      this.prefund = {
        show: true, loading: false,
        kontragentList: [], kontragentLoading: false, kontragentSearch: '',
        kontragentSearchTimer: null,
        selectedKontragent: null, kontragentDebt: 0,
        productResults: [], productLoading: false, productPicker: null,
        productSearchTimer: null, scannerCode: '',
        purchasedProducts: [], purchasedLoading: false,
        payMode: 'debt',
        payTypes: [], payAmounts: {}, dollarRate: 12500,
        items: [], comment: '', restock: true, cashRefund: false,
      };
      // Joriy kurs + to'lov turlari (dinamik)
      this.loadCurrentDollarRate();
      this.loadRefundPayTypes();
      // Mijozlar ro'yxatini bir marta yuklab olamiz (balans bilan)
      await this.loadPrefundKontragents();
      // Skanyerga avtomatik fokus (mobile uchun)
      this.$nextTick(() => {
        const el = this.$refs.scannerInput;
        if (el) el.focus();
      });
    },

    async loadCurrentDollarRate() {
      try {
        const r = await axios.get('/api/v1/dollar-exchange-rate/last');
        const rate = Number((r.data && r.data.rate) || 0);
        if (rate > 0) this.prefund.dollarRate = rate;
      } catch (_) { /* default 12500 */ }
    },
    async loadRefundPayTypes() {
      try {
        const r = await axios.get('/api/v1/pay-type/');
        const list = Array.isArray(r.data) ? r.data : (r.data.data || []);
        this.prefund.payTypes = list.sort((a, b) => a.id - b.id);
        const amounts = {};
        list.forEach(pt => { amounts[pt.id] = 0; });
        this.prefund.payAmounts = amounts;
      } catch (_) {
        // fallback — standart turlar
        this.prefund.payTypes = [{ id: 1, name: 'Naqd' }, { id: 2, name: 'Plastik' }, { id: 3, name: 'Dollar' }];
        this.prefund.payAmounts = { 1: 0, 2: 0, 3: 0 };
      }
    },
    isDollarPayType(pt) {
      const n = String((pt && pt.name) || '').toLowerCase();
      return n.includes('dollar') || n.includes('usd') || n.includes('$') || n.startsWith('доллар');
    },

    async loadPrefundKontragents(query = '') {
      this.prefund.kontragentLoading = true;
      try {
        // Backend: /balances → { items: [...], pagination: {...} }, limit clamped to 200
        // Pagination orqali barchasini yuklab olamiz (qidiruv bo'sh bo'lsa)
        let allItems = [];
        let page = 1;
        const limit = 200;
        let hasMore = true;
        while (hasMore && page <= 50) { // 50 × 200 = 10 000 mijoz limiti
          const res = await axios.get('/api/v1/kontragent/balances', {
            params: { type: 1, limit, page, q: query || undefined },
          });
          const items = (res.data && res.data.items) || [];
          allItems = allItems.concat(items);
          hasMore = (res.data && res.data.pagination && res.data.pagination.has_more) || false;
          page++;
          if (query) break; // qidiruv bo'lsa faqat 1-sahifa yetadi
        }
        this.prefund.kontragentList = allItems;
      } catch (e) {
        console.warn('[REFUND] /balances xato, fallback /type/1 ga:', e.message);
        // Fallback: oddiy ro'yxat (balans yo'q)
        try {
          const res2 = await axios.get('/api/v1/kontragent/type/1');
          const raw = res2.data;
          // Type/1 ham turli formatda kelishi mumkin
          const list = Array.isArray(raw) ? raw
            : (raw && raw.data) ? raw.data
            : (raw && raw.items) ? raw.items
            : [];
          this.prefund.kontragentList = list.map(k => ({ ...k, balance: 0 }));
        } catch (_) {
          this.prefund.kontragentList = [];
        }
      } finally {
        this.prefund.kontragentLoading = false;
      }
    },

    // Mijoz qidiruv — v-select @search hook
    onKontragentTypeSearch(query) {
      this.prefund.kontragentSearch = query;
      // 2+ harf yozsa server tarafdan qidiramiz (katta DB uchun tezroq)
      clearTimeout(this.prefund.kontragentSearchTimer);
      const q = String(query || '').trim();
      if (q.length < 2) return; // dastlabki ro'yxatda qidirilsin (v-select o'zi filter qiladi)
      this.prefund.kontragentSearchTimer = setTimeout(() => {
        this.loadPrefundKontragents(q);
      }, 300);
    },

    onKontragentSelected(k) {
      if (!k) {
        this.prefund.kontragentDebt = 0;
        this.prefund.selectedKontragent = null;
        this.prefund.purchasedProducts = [];
        return;
      }
      // Mijoz sotib olgan mahsulotlarni yuklaymiz (qaytarish uchun tanlash)
      this.loadPurchasedProducts(k.id);
      // balance > 0 → kontragent BIZGA qarzdor (qaytarish bilan qarz kamayadi)
      // balance < 0 → biz kontragentga qarzdormiz (haqdor)
      const bal = Number(k.balance || 0);
      this.prefund.kontragentDebt = bal > 0 ? bal : 0;
      // Auto-tanlash: qarzi bor → qarzdan ushlash, qarzi yo'q → kassadan naqd qaytarish
      this.prefund.payMode = this.prefund.kontragentDebt > 0 ? 'debt' : 'cash';
      // Cash rejimi default: hammasini birinchi so'm to'lov turiga (eng keng tarqalgan holat)
      if (this.prefund.payMode === 'cash') {
        this.defaultFillCash();
      }
    },

    // Cash rejim default: barcha pay_type 0, birinchi so'mli turga prefundTotal
    defaultFillCash() {
      const types = this.prefund.payTypes || [];
      const firstSum = types.find(pt => !this.isDollarPayType(pt)) || types[0];
      types.forEach(pt => { this.$set(this.prefund.payAmounts, pt.id, 0); });
      if (firstSum) this.$set(this.prefund.payAmounts, firstSum.id, this.prefundTotal || 0);
    },

    // ⚡ Tugmasi: qolgan summani shu to'lov turiga to'ldirish
    // ⚡ Tanlangan to'lov turiga qolgan summani to'ldirish (dinamik pay_type bo'yicha)
    fillPayTypeRemaining(pt) {
      const others = (this.prefund.payTypes || []).reduce((sum, p) => {
        if (p.id === pt.id) return sum;
        const amt = Number(this.prefund.payAmounts[p.id] || 0);
        return sum + (this.isDollarPayType(p) ? amt * Number(this.prefund.dollarRate || 0) : amt);
      }, 0);
      const remainingSum = Math.max(0, this.prefundTotal - others);
      const val = this.isDollarPayType(pt)
        ? Number((remainingSum / Number(this.prefund.dollarRate || 1)).toFixed(2))
        : remainingSum;
      this.$set(this.prefund.payAmounts, pt.id, val);
    },

    // Mahsulot v-select async qidiruv
    onProductTypeSearch(query, loading) {
      clearTimeout(this.prefund.productSearchTimer);
      const q = String(query || '').trim();
      if (q.length < 2) {
        this.prefund.productResults = [];
        if (loading) loading(false);
        return;
      }
      if (loading) loading(true);
      this.prefund.productLoading = true;
      this.prefund.productSearchTimer = setTimeout(async () => {
        try {
          const sklad_id = parseInt(localStorage.getItem('sklad_id') || '1');
          const res = await axios.post('/api/v1/product/all-price-balance/0', {
            sklad_id, keyword: q, limit: 25, page: 1,
            datetime: Math.floor(Date.now() / 1000),
          });
          const list = res.data || [];
          this.prefund.productResults = Array.isArray(list) ? list.filter(p => !p.is_folder).slice(0, 25) : [];
        } catch (_) { this.prefund.productResults = []; }
        finally {
          this.prefund.productLoading = false;
          if (loading) loading(false);
        }
      }, 250);
    },

    onProductSelected(p) {
      if (!p) return;
      this.addPrefundItem(p);
      // v-select tozalash
      this.$nextTick(() => { this.prefund.productPicker = null; });
    },

    // Barcode scanner: Enter bosilganda barcode'ga API chaqirish
    async onBarcodeScanned() {
      const code = (this.prefund.scannerCode || '').trim();
      if (!code) return;
      try {
        const res = await axios.get(`/api/v1/product/shtrix/${encodeURIComponent(code)}`);
        const p = Array.isArray(res.data) ? res.data[0] : res.data;
        if (!p || !p.id) {
          alert(`❌ "${code}" shtrixli mahsulot topilmadi`);
          this.prefund.scannerCode = '';
          return;
        }
        this.addPrefundItem(p);
        this.prefund.scannerCode = '';
        // Skanyerga qaytarish (keyingi scan uchun)
        this.$nextTick(() => {
          const el = this.$refs.scannerInput;
          if (el) el.focus();
        });
      } catch (e) {
        alert(`❌ Skanerga xato: ${e.response?.data?.message || e.message}`);
        this.prefund.scannerCode = '';
      }
    },

    // Umumiy: mahsulotni ro'yxatga qo'shish (manba: v-select yoki scanner)
    addPrefundItem(p) {
      const existing = this.prefund.items.find(it => it.id === p.id);
      if (existing) {
        existing.count = Number(existing.count || 0) + 1;
      } else {
        // Narx: chakana_price yoki price (shtrix javobida bo'lishi mumkin)
        const reg = p.price_register || {};
        const price = Number(reg.chakana_price || p.chakana_price || p.price || 0);
        this.prefund.items.push({
          id: p.id,
          name: p.extra_name || p.name || '—',
          count: 1,
          price,
        });
      }
    },

    // Mijoz qaytarsa bo'ladigan mahsulotlar — backend hisoblaydi:
    // qoldi (count) = olingan (bought) − mustaqil refundlar (refunded). Savdoning o'zidan
    // qaytarish savdo itemlarini allaqachon kamaytirgan, shu sabab u avtomatik hisobga olinadi.
    async loadPurchasedProducts(kontragentId) {
      this.prefund.purchasedLoading = true;
      this.prefund.purchasedProducts = [];
      try {
        const res = await axios.get(`/api/v1/service-sale/purchased/${kontragentId}`);
        const list = Array.isArray(res.data) ? res.data : (res.data.data || []);
        // count = remaining (limit logikasi shu maydonni ishlatadi)
        this.prefund.purchasedProducts = list.map(p => ({
          product_id: p.product_id,
          name: p.name,
          price: Number(p.price || 0),
          bought: Number(p.bought || 0),
          refunded: Number(p.refunded || 0),
          count: Number(p.remaining != null ? p.remaining : p.bought || 0),
        }));
      } catch (e) {
        console.warn('[REFUND] mijoz xaridlari yuklanmadi:', e.message);
        this.prefund.purchasedProducts = [];
      } finally {
        this.prefund.purchasedLoading = false;
      }
    },

    // Sotib olingan mahsulot uchun tanlangan qaytarish soni (prefund.items'dan)
    purchasedSelectedQty(p) {
      const it = this.prefund.items.find(x => x.id === p.product_id && Number(x.price) === Number(p.price));
      return it ? Number(it.count || 0) : 0;
    },
    // Ro'yxatdan +1 (sotib olganidan ko'p emas)
    incPurchased(p) {
      const it = this.prefund.items.find(x => x.id === p.product_id && Number(x.price) === Number(p.price));
      if (it) {
        const next = Number(it.count || 0) + 1;
        it.count = Math.min(next, Number(p.count || next));
        it.maxCount = Number(p.count);
      } else {
        this.prefund.items.push({ id: p.product_id, name: p.name, count: 1, price: Number(p.price), maxCount: Number(p.count) });
      }
    },
    // Jadvalda son qo'lda kiritilganda — olgan miqdoridan oshmasin (xaridlardan kelgan mahsulotlar uchun)
    clampItemCount(it) {
      const max = Number(it.maxCount || 0);
      if (max > 0 && Number(it.count || 0) > max) {
        it.count = max;
      }
    },
    // Ro'yxatdan −1 (0 ga yetganda ro'yxatdan o'chiriladi)
    decPurchased(p) {
      const idx = this.prefund.items.findIndex(x => x.id === p.product_id && Number(x.price) === Number(p.price));
      if (idx === -1) return;
      const next = Number(this.prefund.items[idx].count || 0) - 1;
      if (next <= 0) this.prefund.items.splice(idx, 1);
      else this.prefund.items[idx].count = next;
    },

    async submitProductRefund() {
      if (!this.canSubmitPrefund) return;
      this.prefund.loading = true;
      try {
        const sklad_id = parseInt(localStorage.getItem('sklad_id') || '1');
        const totalCount = this.prefund.items.reduce((s, it) => s + Number(it.count || 0), 0);
        const totalSumma = this.prefundTotal;

        const hasClient = !!this.prefund.selectedKontragent;
        // Pul kassadan chiqadigan holatlar: (mijoz + cash rejim) YOKI (mijozsiz + pul qaytarish belgilangan)
        const cashMode = (hasClient && this.prefund.payMode === 'cash') || (!hasClient && this.prefund.cashRefund);

        // DINAMIK to'lov turlari (pay_type_id) — faqat cashMode'da
        const payments = cashMode
          ? (this.prefund.payTypes || [])
              .map(pt => ({
                pay_type_id: pt.id,
                name: pt.name,
                isDollar: this.isDollarPayType(pt),
                summa: Number(this.prefund.payAmounts[pt.id] || 0),
              }))
              .filter(p => p.summa > 0)
          : [];

        let defaultComment;
        if (!hasClient) defaultComment = cashMode ? 'Mahsulot qaytarish (mijozsiz — pul qaytarildi)' : 'Mahsulot qaytarish (mijozsiz — faqat omborga)';
        else if (cashMode) defaultComment = 'Mahsulot qaytarish (kassadan to\'lov turlari bo\'yicha)';
        else defaultComment = 'Mahsulot qaytarish (qarzdan ushlash)';

        const payload = {
          created_at: Math.floor(Date.now() / 1000),
          updated_at: Math.floor(Date.now() / 1000),
          sklad_id,
          kontragent_id: hasClient ? this.prefund.selectedKontragent.id : 0,
          user_id: null,
          summa: totalSumma,
          count_all: totalCount,
          skidka_summa: 0,
          // DINAMIK to'lov turlari (backend kassa/qarz yozuvlarini shu bo'yicha yozadi)
          payments: payments.map(p => ({
            pay_type_id: p.pay_type_id,
            summa: p.summa,
            dollar_rate: p.isDollar ? Number(this.prefund.dollarRate || 1) : 1,
          })),
          // Legacy maydonlar 0 — backend payments[] ni ishlatadi
          cash_summa: 0,
          plastic_summa: 0,
          dollar_summa: 0,
          dollar_rate:   Number(this.prefund.dollarRate || 1),
          pay_type_id: 1,
          price_type: 'chakana',
          restock: this.prefund.restock !== false,
          comment: this.prefund.comment || defaultComment,
          number: 0,
          refund_table: this.prefund.items.map(it => ({
            product_id: it.id,
            count: Number(it.count),
            price: Number(it.price),
            summa: Number(it.count) * Number(it.price),
          })),
        };

        const res = await axios.post('/api/v1/refund', payload);
        const refundId = res.data && res.data.id;

        const payPartsStr = payments
          .map(p => `${p.name}: ${p.isDollar ? '$' + this.formatMoney(p.summa) : this.formatMoney(p.summa) + ' UZS'}`)
          .join(' + ') || '0';

        let debtLine, cashLine;
        if (!hasClient) {
          debtLine = `💰 Qarz: tegilmadi (mijozsiz)`;
          cashLine = cashMode ? `💵 Kassa chiqimi: ${payPartsStr}` : `💵 Kassa: o'zgarmadi`;
        } else if (cashMode) {
          debtLine = `💰 ${this.prefund.selectedKontragent.name} qarzi: o'zgarmadi`;
          cashLine = `💵 Kassa chiqimi: ${payPartsStr}`;
        } else {
          debtLine = `💰 ${this.prefund.selectedKontragent.name} qarzi: -${this.formatMoney(totalSumma)} UZS`;
          cashLine = `💵 Kassa: o'zgarmadi`;
        }
        const omborLine = this.prefund.restock
          ? `📦 Ombor: +${totalCount} ta · ${this.formatMoney(totalSumma)} UZS`
          : `📦 Ombor: o'zgarmadi (yaroqsiz — qaytmadi)`;
        alert(`✅ Qaytarish saqlandi (#${refundId})!\n\n${omborLine}\n${debtLine}\n${cashLine}`);
        this.prefund.show = false;
        this.fetchSales();
      } catch (e) {
        const msg = e.response && e.response.data && (e.response.data.message || e.response.data.errors?.[0]?.msg) || e.message;
        alert('❌ Xatolik: ' + msg);
      } finally {
        this.prefund.loading = false;
      }
    },

    /* ─── Auto-polling: yangi savdolarni avtomatik tekshirish ─── */
    startAutoPolling() {
      this.stopAutoPolling();
      this.pollingTimer = setInterval(() => {
        if (!document.hidden) this.checkNewSales();
      }, this.pollingInterval);
    },
    stopAutoPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },
    onVisibilityChange() {
      // Sahifa orqaga ketsa polling to'xtaydi (battery/trafik tejash)
      if (document.hidden) return;
      // Sahifa qaytsa darhol tekshirib olamiz
      this.checkNewSales();
    },
    async checkNewSales() {
      try {
        // Oxirgi savdo created_at'idan keyingilarini olamiz (delta sync)
        const since = this.lastKnownSaleId > 0 && this.sales[0]
          ? Number(this.sales[0].created_at || 0)
          : 0;
        const res = await axios.get('api/v1/service-sale/recent', {
          params: { since, limit: 50 }
        });
        const items = (res.data && res.data.items) || [];
        if (items.length > 0) {
          // Filter date oralig'idagilarni faqat qo'shamiz (master filter ham hisobga olinadi)
          const inRange = items.filter(s => {
            if (this.filterMasterId && s.master_user_id != this.filterMasterId) return false;
            return true;
          });
          if (inRange.length > 0) {
            // Eski list bilan birlashtiramiz (ID dublikatlarini chiqarib)
            const existingIds = new Set(this.sales.map(s => s.id));
            const fresh = inRange.filter(s => !existingIds.has(s.id));
            if (fresh.length > 0) {
              this.sales = [...fresh, ...this.sales];
              this.newSalesCount += fresh.length;
              this.lastKnownSaleId = res.data.newest_id || this.lastKnownSaleId;
              // Brauzer notification (ixtiyoriy — agar ruxsat bo'lsa)
              this.flashTitle(fresh.length);
            }
          }
        }
      } catch (e) {
        // jim — keyingi pollingda qaytariladi
      }
    },
    flashTitle(count) {
      // Document title'ga "(N) Savdolar" qo'yib diqqat tortish
      const original = 'Savdolar Ro\'yxati';
      document.title = `(${count}) ${original}`;
      setTimeout(() => { document.title = original; }, 4000);
    },
    clearNewSales() {
      this.newSalesCount = 0;
    },
    async fetchPayTypes() {
      try {
        const res = await axios.get('api/v1/pay-type/');
        this.payTypes = (res.data || []).sort((a, b) => a.id - b.id);
      } catch (e) {
        this.payTypes = [];
      }
    },
    async fetchMasters() {
      try {
        const res = await axios.get('api/v1/staff');
        this.masters = res.data?.data || [];
      } catch (e) {
        this.masters = [];
      }
    },
    async fetchSales() {
      this.loading = true;
      try {
        const params = {};
        if (this.filterDate1) params.date1 = Math.floor(new Date(this.filterDate1).getTime() / 1000);
        if (this.filterDate2) params.date2 = Math.floor(new Date(this.filterDate2 + 'T23:59:59').getTime() / 1000);
        if (this.filterMasterId) params.master_user_id = this.filterMasterId;
        const res = await axios.get('api/v1/service-sale', { params });
        this.sales = Array.isArray(res.data) ? res.data : [];
        this.lastKnownSaleId = this.sales[0] ? this.sales[0].id : 0;
        this.newSalesCount = 0;
      } catch (e) {
        console.error('Savdolarni yuklashda xato:', e);
        this.sales = [];
      } finally {
        this.loading = false;
      }
    },
    // original_summa: yangi yozuvda to'g'ridan keladi; eski yozuv uchun summa+skidka fallback.
    getOriginalSumma(item) {
      const v = Number(item.original_summa || 0);
      return v > 0 ? v : Number(item.summa || 0) + Number(item.skidka_summa || 0);
    },
    // arzon_summa: per-item arzonlatish. Eski yozuvlarda 0.
    getArzonSumma(item) {
      return Number(item.arzon_summa || 0);
    },
    // discount_summa: qo'shimcha chegirma. Eski yozuv uchun skidka_summa fallback.
    getDiscountSumma(item) {
      const v = Number(item.discount_summa || 0);
      return v > 0 ? v : Number(item.skidka_summa || 0);
    },
    // paid_summa: to'langan summa. Eski yozuv uchun cash+plastic+shot fallback.
    getPaidSumma(item) {
      const v = Number(item.paid_summa || 0);
      if (v > 0) return v;
      return Number(item.cash_summa || 0) + Number(item.plastic_summa || 0) + Number(item.shot_summa || 0);
    },
    // qarz_summa: qarz summasi. Eski yozuv uchun summa − paid fallback.
    getQarzSumma(item) {
      const v = Number(item.qarz_summa || 0);
      if (v > 0) return v;
      return Math.max(0, Number(item.summa || 0) - this.getPaidSumma(item));
    },
    // Eski nomi — to'lov modali va getDebtClass uchun saqlanadi.
    getPaid(item)  { return this.getPaidSumma(item); },
    getDebt(item)  { return this.getQarzSumma(item); },

    /* ─── TOIFA: arzon / chegirmali / to'liq / qimmat ─── */
    // pct > 0 = chegirma berilgan; pct < 0 = qimmatga sotilgan (ustama); pct = 0 = to'liq
    getSalePct(item) {
      const original = this.getOriginalSumma(item);
      const summa = Number(item.summa || 0);
      if (original <= 0) return 0;
      const pct = ((original - summa) / original) * 100;
      return Math.round(pct * 10) / 10;
    },
    getSaleCategory(item) {
      const original = this.getOriginalSumma(item);
      const summa = Number(item.summa || 0);
      if (original <= 0) return 'unknown';
      if (summa > original) return 'premium';     // QIMMAT
      const pct = ((original - summa) / original) * 100;
      if (pct === 0)      return 'full';          // to'liq narx
      if (pct < 10)       return 'small';         // kichik chegirma
      if (pct < 20)       return 'discount';      // chegirmali
      return 'cheap';                             // ARZON
    },
    getCategoryLabel(item) {
      const c = this.getSaleCategory(item);
      return {
        premium:  'Qimmat',
        full:     "To'liq",
        small:    'Mayda',
        discount: 'Chegirma',
        cheap:    'Arzon',
        unknown:  '—',
      }[c] || '—';
    },
    getCategoryTooltip(item) {
      const original = this.getOriginalSumma(item);
      const summa = Number(item.summa || 0);
      const pct = this.getSalePct(item);
      return `Asl: ${this.formatMoney(original)} → Sotilgan: ${this.formatMoney(summa)} (${pct > 0 ? '-' : pct < 0 ? '+' : ''}${Math.abs(pct)}%)`;
    },
    // Mobil scanner uchun barcode qiymati: "<created_at>_<id>".
    // Backend GET /api/v1/service-sale/by-code/:code shu kodni tushunadi.
    saleBarcode(item) {
      if (!item || !item.id || !item.created_at) return '';
      return `${item.created_at}_${item.id}`;
    },
    // Print oynasi uchun barcode SVG markup'ini JsBarcode bilan generatsiya qiladi.
    // (vue-barcode komponent — yangi window ichida ishlamaydi, shuning uchun raw SVG kerak.)
    renderBarcodeSvg(value) {
      if (!value) return '';
      try {
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        JsBarcode(svg, value, {
          format: 'CODE128',
          displayValue: true,
          fontSize: 14,
          height: 50,
          width: 1.6,
          margin: 0,
          textMargin: 2,
        });
        return svg.outerHTML;
      } catch (e) {
        return '';
      }
    },
    getDebtClass(item) {
      return this.getDebt(item) > 0 ? 'price red' : 'price green';
    },
    formatMoney(v) {
      if (!v || v === 0) return '0';
      return Number(v).toLocaleString('ru-RU').replace(/,/g, ' ');
    },
    isPayDollar(p) {
      const n = String(p && p.pay_type && p.pay_type.name || '').toLowerCase();
      return n.includes('dollar') || n.includes('usd') || n.includes('$') || n.startsWith('доллар');
    },
    payPillIcon(name) {
      const n = String(name || '').toLowerCase();
      if (n.includes('dollar') || n.includes('usd') || n.includes('$') || n.startsWith('доллар')) return '💲';
      if (n.includes('plast') || n.includes('пласт') || n.includes('card') || n.includes('uzcard') || n.includes('humo')) return '💳';
      if (n.includes('shot') || n.includes('шот') || n.includes('перевод')) return '📲';
      if (n.includes('naqd') || n.includes('нақд') || n.includes('cash')) return '💵';
      return '💰';
    },
    payPillClass(name) {
      const n = String(name || '').toLowerCase();
      if (n.includes('dollar') || n.includes('usd') || n.includes('$') || n.startsWith('доллар')) return 'pp-dollar';
      if (n.includes('plast') || n.includes('uzcard') || n.includes('humo') || n.includes('card')) return 'pp-plastic';
      if (n.includes('shot') || n.includes('перевод')) return 'pp-shot';
      if (n.includes('naqd') || n.includes('cash')) return 'pp-naqd';
      return 'pp-other';
    },
    // Qisqa format: 1,500,000 → 1.5M, 250,000 → 250K
    formatShort(v) {
      const n = Number(v || 0);
      if (n === 0) return '0';
      if (n >= 1000000) {
        const m = (n / 1000000);
        return (m % 1 === 0 ? m.toFixed(0) : m.toFixed(1)) + 'M';
      }
      if (n >= 1000) {
        const k = (n / 1000);
        return (k % 1 === 0 ? k.toFixed(0) : k.toFixed(1)) + 'K';
      }
      return String(n);
    },
    formatDate(ts) {
      if (!ts) return '-';
      const date = new Date(ts * 1000);
      return date.toLocaleDateString('ru-RU') + ' ' + date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
    },
    formatDueDate(ts) {
      if (!ts) return '-';
      const d = new Date(Number(ts) * 1000);
      const months = ['yan', 'fev', 'mar', 'apr', 'may', 'iyn', 'iyl', 'avg', 'sen', 'okt', 'noy', 'dek'];
      return `${d.getDate()} ${months[d.getMonth()]}, ${d.getFullYear()}`;
    },
    // Mahsulot arzon sotilganmi (asl narxidan past)?
    isArzon(itm) {
      const orig = Number((itm || {}).original_price || 0);
      const price = Number((itm || {}).price || 0);
      return orig > 0 && orig > price;
    },
    openDetailModal(item) {
      this.detailItem = item;
      this.showDetailModal = true;
    },
    closeDetailModal() {
      this.showDetailModal = false;
      this.detailItem = null;
    },
    openDeleteModal(item) {
      this.selectedItem = item;
      this.showDeleteModal = true;
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
      this.selectedItem = null;
    },
    async fetchSkladSettings() {
      const sklad_id = localStorage.getItem('sklad_id');
      if (!sklad_id) return;
      try {
        const [skladRes, settingsRes] = await Promise.all([
          axios.get(`api/v1/sklads/id/${sklad_id}`),
          axios.post('api/v1/sklad-settings', { sklad_id, key: 'a4_printer' }),
        ]);
        const sklad = skladRes.data?.data || skladRes.data || {};
        this.skladSettings.phone = sklad.phone_number || '';
        this.skladSettings.checkWord = sklad.check_word || '';
        const printerData = settingsRes.data?.data;
        if (printerData) {
          const parsed = JSON.parse(printerData);
          this.skladSettings.firmName = parsed?.sender?.firm_name || sklad.name || '';
          if (parsed?.file_name) {
            this.skladSettings.logoUrl = axios.defaults.baseURL + 'api/v1/uploads/' + parsed.file_name;
          }
        } else {
          this.skladSettings.firmName = sklad.name || '';
        }
      } catch (e) { console.error('Sklad sozlamalari xato', e); }
    },
    // Chek chiqarish. Savdoda qaytarish bo'lsa — rejimni tanlash modali chiqadi:
    //   'sale'   — faqat savdo cheki (qolgan mahsulotlar)
    //   'both'   — savdo + qaytarilgan bitta chekda (yakuniy hisob bilan)
    //   'refund' — faqat qaytarilgan (alohida chek)
    async printSaleReceipt(item) {
      let refunds = [];
      try {
        const r = await axios.get(`api/v1/service-sale/id/${item.id}/refunds`);
        refunds = Array.isArray(r.data) ? r.data : [];
      } catch (e) {
        refunds = [];   // tarix o'qilmasa ham oddiy savdo cheki chiqaverishi kerak
      }
      if (refunds.length === 0) {
        return this.renderSaleReceipt(item, []);
      }
      this.printChoice = { show: true, item, refunds };
    },
    runPrintChoice(mode) {
      const item = this.printChoice.item;
      const refunds = this.printChoice.refunds || [];
      this.printChoice.show = false;
      if (!item) return;
      if (mode === 'refund') return this.printRefundOnly(item, refunds);
      return this.renderSaleReceipt(item, mode === 'both' ? refunds : []);
    },
    // Savdodagi qaytarishlar uchun ALOHIDA chek (savdo pozitsiyalarisiz)
    printRefundOnly(item, refunds) {
      const s = this.skladSettings;
      const rows = [];
      (refunds || []).forEach(r => {
        (r.items || []).forEach(i => rows.push({ name: i.name, count: i.count, price: i.price, summa: i.summa, unit: i.unit }));
        (r.services || []).forEach(sv => rows.push({ name: sv.name + ' (xizmat)', count: 1, price: sv.summa, summa: sv.summa, unit: 'xizmat' }));
      });
      const totalQty = rows.reduce((sum, r) => sum + Number(r.count || 0), 0);
      const totalSum = (refunds || []).reduce((sum, r) => sum + Number(r.summa || 0), 0);

      // Qaytarilgan pul — barcha qaytarishlarning to'lovlari, pay_type bo'yicha yig'iladi
      const payMap = {};
      (refunds || []).forEach(r => (r.payments || []).forEach(p => {
        const key = p.pay_type_name || ("To'lov #" + p.pay_type_id);
        payMap[key] = (payMap[key] || 0) + Number(p.summa || 0);
      }));
      const payHtml = Object.keys(payMap).length
        ? Object.keys(payMap).map(name =>
            `<div class="leader-line"><span class="ll-left">Qaytarildi (${name})</span><span class="ll-dots"></span><span class="ll-right">${rcpMoney(payMap[name])} UZS</span></div>`
          ).join('')
        : `<div class="leader-line"><span class="ll-left">Pul qaytarish</span><span class="ll-dots"></span><span class="ll-right">${item.kontragent ? 'Mijoz qarzidan ushlandi' : 'Yo\'q'}</span></div>`;

      const whenHtml = (refunds || []).map(r =>
        `<div class="refund-when">${rcpDate(r.datetime)}${r.comment ? ' — ' + r.comment : ''} · ${rcpMoney(r.summa)} UZS</div>`
      ).join('');

      const body = `
        ${receiptHeaderHtml(s, rcpDate(Math.floor(Date.now() / 1000)), 'Qaytarish cheki')}
        <div class="receipt-info">
          <div class="info-row"><span class="info-label">Savdo:</span><span class="info-value">№ ${item.number || item.id}, ${this.formatDate(item.created_at)}</span></div>
          <div class="info-row"><span class="info-label">Mijoz:</span><span class="info-value">${item.kontragent ? item.kontragent.name : "NOMA'LUM"}</span></div>
        </div>
        <div class="items-section">${rows.map(itemBlockHtml).join('')}</div>
        <div class="calc-section">
          <div class="leader-line"><span class="ll-left">Qaytarilgan pozitsiyalar</span><span class="ll-dots"></span><span class="ll-right">${rcpMoney(totalQty)} birlik.</span></div>
          <div class="leader-line ll-jami"><span class="ll-left">JAMI QAYTARILDI</span><span class="ll-dots"></span><span class="ll-right">${rcpMoney(totalSum)} UZS</span></div>
          ${payHtml}
        </div>
        <div class="refund-section">
          <div class="refund-title">Qaytarish tarixi</div>
          ${whenHtml}
        </div>
        <div class="receipt-divider"></div>
        <div class="receipt-footer">
          ${s.checkWord ? `<div class="check-word">${s.checkWord}</div>` : ''}
        </div>`;

      openReceiptWindow(`Qaytarish — Savdo #${item.id}`, body);
    },
    async renderSaleReceipt(item, refunds = []) {
      // Chek uchun mijozning "oldingi qarzi" — savdolar ro'yxati javobida bo'lmasligi mumkin.
      // Shu sabab savdo detalidan (backend markaziy hisobidan) olamiz. Excel'dan yuklangan
      // boshlang'ich qarz ham shu qiymatga kiradi.
      if (item.previous_debt == null && item.kontragent_id) {
        try {
          const r = await axios.get(`api/v1/service-sale/id/${item.id}`);
          item.previous_debt = Number((r.data && r.data.previous_debt) || 0);
        } catch (e) { item.previous_debt = 0; }
      }
      const s = this.skladSettings;
      const clientName = item.kontragent ? item.kontragent.name : "NOMA'LUM";
      const masterName = item.master ? item.master.name : '';
      const carNumber = item.car_number || '';
      const date = this.formatDate(item.created_at);
      const fmt = (v) => this.formatMoney(v);
      const fmtUZS = (v) => this.formatMoney(v) + ' UZS';

      // Mahsulotlar royxatini yigamiz (har biri: { name, qty, price, total })
      const rows = [];
      if (item.packages && item.packages.length > 0) {
        item.packages.forEach(pkg => {
          const total = Number(pkg.labor_price_chakana || 0) + Number(pkg.redo_price_chakana || 0) + Number(pkg.labor_price_optom || 0) + Number(pkg.redo_price_optom || 0);
          rows.push({ name: pkg.name || '-', qty: 1, price: total, total });
        });
      } else if (item.repair_package) {
        const total = Number(item.labor_price_chakana || 0) + Number(item.redo_price_chakana || 0) + Number(item.labor_price_optom || 0) + Number(item.redo_price_optom || 0);
        rows.push({ name: item.repair_package.name, qty: 1, price: total, total });
      }
      const showAlt = item.price_type === 'optom';
      if (item.items && item.items.length > 0) {
        item.items.forEach(itm => {
          const name = itm.product ? (itm.product.name || itm.product.extra_name) : '-';
          const pr = itm.product && itm.product.price_register;
          const reg = Array.isArray(pr) ? pr[0] : pr;
          let altPrice = 0;
          if (showAlt && reg) {
            altPrice = Number(reg.chakana_price || 0);
          }
          // Asl narx — service_sale_table.original_price'dan (savdo paytida saqlangan).
          // FAQAT sotilgan narxdan QIMMAT bo'lsa chizib ko'rsatiladi (arzon sotildi).
          // Qimmat sotilganda yashiramiz — mijoz asl narxni bilmasin.
          const soldPrice = Number(itm.price || 0);
          const origRaw   = Number(itm.original_price || 0);
          const origPrice = (origRaw > 0 && origRaw > soldPrice) ? origRaw : 0;
          rows.push({
            name,
            qty: Number(itm.count || 0),
            // O'lchov birligi mahsulot kartochkasidan (kg, m, m², sht...)
            unit: (itm.product && itm.product.unit && itm.product.unit.name) || '',
            price: soldPrice,
            total: Number(itm.summa || 0),
            altPrice,
            origPrice,
            discountPct: Number(itm.discount_percent || 0),
          });
        });
      }

      const totalQty = rows.reduce((sum, r) => sum + Number(r.qty || 0), 0);
      // Narx tushirish orqali jami chegirma
      const priceReduction = rows.reduce((s, r) => {
        const orig = Number(r.origPrice || 0);
        if (orig > 0) return s + (orig - Number(r.price)) * Number(r.qty || 0);
        return s;
      }, 0);
      const originalTotalSum = rows.reduce((s, r) => {
        const base = Number(r.origPrice || 0) > 0 ? Number(r.origPrice) : Number(r.price);
        return s + base * Number(r.qty || 0);
      }, 0);
      const skidka = Number(item.skidka_summa || 0);
      const paidSumma = this.getPaidSumma(item);
      const qarzSumma = this.getQarzSumma(item);
      const totalSum = Number(item.summa || 0);
      const previousDebt = Number(item.previous_debt || 0);
      const debtDueDate = Number(item.debt_due_date || 0);
      const debtComment = item.debt_comment || '';
      const fmtDueDate = (ts) => {
        if (!ts) return '';
        const d = new Date(Number(ts) * 1000);
        return [
          String(d.getDate()).padStart(2, '0'),
          String(d.getMonth() + 1).padStart(2, '0'),
          d.getFullYear(),
        ].join('.');
      };

      // Bitta mahsulot bloki. Birlik (шт/кг/м²...) mahsulot kartochkasidan olinadi;
      // ko'rsatilmagan bo'lsa — "шт".
      const renderRow = (r, i) => {
        const u = rcpUnit(r.unit);
        return `
        <div class="item-block">
          <div class="ir-name">${i + 1}. ${r.name}</div>
          ${r.altPrice > 0 ? `<div class="ir-alt">Chakana narxi: ${fmtUZS(r.altPrice)}</div>` : ''}
          ${r.origPrice > 0 ? `
            <div class="leader-line ll-strike">
              <span class="ll-left">${r.qty} ${u} x ${fmt(r.origPrice)}</span>
              <span class="ll-dots"></span>
              <span class="ll-right">${fmtUZS(r.qty * r.origPrice)}</span>
            </div>` : ''}
          ${(r.discountPct || 0) > 0 && r.origPrice > 0 ? `<div class="ir-disc">−${r.discountPct}% chegirma · tejaldi: <b>${fmtUZS((r.origPrice - r.price) * r.qty)}</b></div>` : ((r.discountPct || 0) > 0 ? `<div class="ir-disc">−${r.discountPct}% chegirma</div>` : '')}
          <div class="leader-line">
            <span class="ll-left">${r.qty} ${u} x ${fmt(r.price)}</span>
            <span class="ll-dots"></span>
            <span class="ll-right">${fmtUZS(r.total)}</span>
          </div>
        </div>`;
      };

      // Chek bo'lish rejimi: 0 = uzmasdan, N = har N ta mahsulotdan keyin yangi sahifa
      const splitN = parseInt(this.printSplit || 0) || 0;
      let itemsHtml = '';
      if (splitN > 0 && rows.length > splitN) {
        // Mahsulotlarni N tadan bo'lib, har bir bo'lakni alohida sahifa qilamiz.
        // page-break-after: always — printerga "kes" signali.
        const totalParts = Math.ceil(rows.length / splitN);
        for (let p = 0; p < totalParts; p++) {
          const start = p * splitN;
          const end = Math.min(start + splitN, rows.length);
          const partRows = rows.slice(start, end);
          const partInner = partRows.map((r, i) => renderRow(r, start + i)).join('');
          const isLast = p === totalParts - 1;
          itemsHtml += `
            <div class="items-section ${isLast ? '' : 'page-break'}">
              <div class="part-marker">— Qism ${p + 1} / ${totalParts} —</div>
              ${partInner}
              ${!isLast ? '<div class="part-cont">▼ Davomi keyingi chekda ▼</div>' : ''}
            </div>`;
        }
      } else {
        itemsHtml = rows.map((r, i) => renderRow(r, i)).join('');
      }

      const logoHtml = s.logoUrl ? `<img src="${s.logoUrl}" class="receipt-logo" alt="logo" />` : '';
      const masterHtml = masterName ? `<div class="info-row"><span class="info-label">Usta:</span><span class="info-value">${masterName}</span></div>` : '';
      const carHtml = carNumber ? `<div class="info-row"><span class="info-label">Mashina:</span><span class="info-value">${carNumber}</span></div>` : '';

      const priceReductionHtml = priceReduction > 0 ? `
        <div class="leader-line ll-strike"><span class="ll-left">Asl jami (narx tushirilmaganda)</span><span class="ll-dots"></span><span class="ll-right">${fmtUZS(originalTotalSum)}</span></div>
        <div class="leader-line"><span class="ll-left">Narx chegirmasi</span><span class="ll-dots"></span><span class="ll-right">- ${fmtUZS(priceReduction)}</span></div>` : '';
      const oraliqHtml = skidka > 0 ? `
        <div class="leader-line"><span class="ll-left">Oraliq jami</span><span class="ll-dots"></span><span class="ll-right">${fmtUZS(totalSum + skidka)}</span></div>
        <div class="leader-line"><span class="ll-left">Chegirma</span><span class="ll-dots"></span><span class="ll-right">- ${fmtUZS(skidka)}</span></div>` : '';
      // To'landi — har pay_type alohida (mobile chek formati)
      // item.payments[] backenddan keladi: { pay_type_id, summa, dollar_rate, summa_in_sum, pay_type_name? }
      let paidHtml = '';
      const itemPayments = Array.isArray(item.payments) ? item.payments.filter(p => Number(p.summa || 0) > 0) : [];
      if (itemPayments.length > 0) {
        // Dollar pay_type ID — utils.Dollar = 3 yoki nom orqali aniqlash
        const dollarById = (id, name) => {
          if (parseInt(id) === 3) return true;
          const n = String(name || '').toLowerCase();
          return n.includes('dollar') || n.includes('usd') || n.includes('$') || n.startsWith('доллар');
        };
        paidHtml = itemPayments.map(p => {
          const ptName = p.pay_type_name || (p.pay_type && p.pay_type.name) || ("To'lov #" + p.pay_type_id);
          const isDollar = dollarById(p.pay_type_id, ptName);
          const amountStr = isDollar ? `$${fmt(p.summa)}` : `${fmt(p.summa)} UZS`;
          return `<div class="leader-line"><span class="ll-left">To'landi (${ptName})</span><span class="ll-dots"></span><span class="ll-right">${amountStr}</span></div>`;
        }).join('');
      } else if (paidSumma > 0) {
        paidHtml = `<div class="leader-line"><span class="ll-left">To'landi</span><span class="ll-dots"></span><span class="ll-right">${fmtUZS(paidSumma)}</span></div>`;
      }

      const debtHtml = (previousDebt > 0 || qarzSumma > 0) ? `
        <div class="debt-section">
          <div class="debt-title">Mijoz qarzi</div>
          <div class="leader-line"><span class="ll-left">Xariddan oldingi qarz</span><span class="ll-dots"></span><span class="ll-right">${fmtUZS(previousDebt)}</span></div>
          <div class="leader-line"><span class="ll-left">Qarzga qo'shildi</span><span class="ll-dots"></span><span class="ll-right">${fmtUZS(qarzSumma)}</span></div>
          <div class="leader-line ll-bold"><span class="ll-left">Xariddan keyingi qarz</span><span class="ll-dots"></span><span class="ll-right">${fmtUZS(previousDebt + qarzSumma)}</span></div>
          ${debtDueDate > 0 ? `<div class="leader-line ll-bold"><span class="ll-left">To'lov muddati</span><span class="ll-dots"></span><span class="ll-right">${fmtDueDate(debtDueDate)}</span></div>` : ''}
          ${debtComment ? `<div class="debt-comment-line">Izoh: ${debtComment}</div>` : ''}
        </div>` : '';

      const checkWordHtml = s.checkWord ? `<div class="check-word">${s.checkWord}</div>` : '';

      // QAYTARILGAN MAHSULOTLAR bo'limi — "savdo + qaytarilgan" rejimida.
      // Qaytarish savdodan allaqachon ayrilgan (JAMI = qaytarishdan keyingi summa),
      // shuning uchun bu yerda boshlang'ich jami ham ko'rsatiladi.
      let refundHtml = '';
      const refundList = Array.isArray(refunds) ? refunds : [];
      if (refundList.length > 0) {
        const refundRows = [];
        refundList.forEach(r => {
          (r.items || []).forEach(i => refundRows.push({ name: i.name, count: i.count, price: i.price, summa: i.summa, unit: i.unit }));
          (r.services || []).forEach(sv => refundRows.push({ name: sv.name + ' (xizmat)', count: 1, price: sv.summa, summa: sv.summa, unit: 'xizmat' }));
        });
        const refundTotal = refundList.reduce((sum, r) => sum + Number(r.summa || 0), 0);
        const refundQty = refundRows.reduce((sum, r) => sum + Number(r.count || 0), 0);

        // Qaytarilgan pul — pay_type bo'yicha yig'indi
        const payMap = {};
        refundList.forEach(r => (r.payments || []).forEach(p => {
          const key = p.pay_type_name || ("To'lov #" + p.pay_type_id);
          payMap[key] = (payMap[key] || 0) + Number(p.summa || 0);
        }));
        const refundPayHtml = Object.keys(payMap).map(name =>
          `<div class="leader-line"><span class="ll-left">Pul qaytarildi (${name})</span><span class="ll-dots"></span><span class="ll-right">${fmtUZS(payMap[name])}</span></div>`
        ).join('');

        const whenHtml = refundList.map(r =>
          `<div class="refund-when">${rcpDate(r.datetime)}${r.comment ? ' — ' + r.comment : ''}</div>`
        ).join('');

        refundHtml = `
        <div class="refund-section">
          <div class="refund-title">🔄 Qaytarilgan mahsulotlar</div>
          ${whenHtml}
          ${refundRows.map((r, i) => `
            <div class="item-block">
              <div class="ir-name">${i + 1}. ${r.name || '-'}</div>
              <div class="leader-line">
                <span class="ll-left">${rcpMoney(r.count)} ${rcpUnit(r.unit)} x ${fmt(r.price)}</span>
                <span class="ll-dots"></span>
                <span class="ll-right">− ${fmtUZS(r.summa)}</span>
              </div>
            </div>`).join('')}
          <div class="leader-line"><span class="ll-left">Qaytarilgan pozitsiyalar</span><span class="ll-dots"></span><span class="ll-right">${rcpMoney(refundQty)} birlik.</span></div>
          <div class="leader-line ll-bold"><span class="ll-left">JAMI QAYTARILDI</span><span class="ll-dots"></span><span class="ll-right">− ${fmtUZS(refundTotal)}</span></div>
          ${refundPayHtml}
          <div class="refund-total-box">
            <div class="leader-line"><span class="ll-left">Boshlang'ich savdo</span><span class="ll-dots"></span><span class="ll-right">${fmtUZS(totalSum + refundTotal)}</span></div>
            <div class="leader-line"><span class="ll-left">Qaytarildi</span><span class="ll-dots"></span><span class="ll-right">− ${fmtUZS(refundTotal)}</span></div>
            <div class="leader-line ll-jami"><span class="ll-left">SOF JAMI</span><span class="ll-dots"></span><span class="ll-right">${fmtUZS(totalSum)}</span></div>
          </div>
        </div>`;
      }

      // Mobil scanner uchun barcode (chek pastida)
      const barcodeSvg = this.renderBarcodeSvg(this.saleBarcode(item));
      const barcodeHtml = barcodeSvg ? `<div class="receipt-barcode">${barcodeSvg}</div>` : '';

      const printWindow = window.open('', '_blank', 'width=420,height=700');
      printWindow.document.write(`<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<title>Chek #${item.id}</title>
<style>
  /* Uzmasdan chiqarish uchun — juda baland sahifa o'lchami beramiz, shunda
     brauzer/printer o'rtada sahifa ajratmaydi (chek doim bitta uzun bo'lakda chiqadi).
     Faqat splitN > 0 bo'lganda .page-break sinfi qo'shiladi va o'sha joyda kesadi. */
  @page { size: 80mm 5000mm; margin: 0; }
  * { margin: 0; padding: 0; box-sizing: border-box; }
  html, body { height: auto; }
  body {
    width: 80mm; font-family: 'Arial Narrow', 'Arial', 'Helvetica', sans-serif;
    font-size: 13px; color: #000; padding: 1.5mm 1mm;
    -webkit-font-smoothing: antialiased; line-height: 1.2;
    /* Avtomatik sahifa ajratishni o'chirish — faqat aniq .page-break joyida kesadi */
    page-break-inside: avoid;
    break-inside: avoid;
  }
  /* Asosiy bloklar ichida sahifa ajratish taqiqlanadi */
  .receipt-header, .receipt-info, .item-block, .calc-section, .debt-section,
  .receipt-footer, .receipt-barcode, .leader-line {
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .receipt-logo { display: block; max-width: 90mm; max-height: 33mm; width: auto; height: auto; margin: 0 auto 2mm; object-fit: contain; }
  .receipt-header { text-align: center; margin-bottom: 2mm; }
  .firm-name { font-size: 18px; font-weight: 900; letter-spacing: 0.5px; text-transform: uppercase; }
  .firm-phone { font-size: 12px; margin-top: 1mm; word-break: break-all; }
  .receipt-date { font-size: 12px; color: #000; margin-top: 1mm; }

  .receipt-divider { border-top: 1.5px dashed #000; margin: 2mm 0; }

  .receipt-info { margin: 1.5mm 0; }
  .info-row { display: flex; justify-content: space-between; font-size: 13px; line-height: 1.3; gap: 4px; }
  .info-label { color: #000; font-weight: 700; white-space: nowrap; }
  .info-value { font-weight: 700; text-align: right; word-break: break-word; }

  .items-section { margin: 1.5mm 0; }
  .item-block { padding: 1.2mm 0; border-top: 1px dashed #000; }
  .item-block:last-child { border-bottom: 1px dashed #000; }
  .page-break { page-break-after: always; break-after: page; }
  .part-marker {
    text-align: center; font-size: 11px; font-weight: 700;
    padding: 1.2mm 0; border-top: 1.5px dashed #000; border-bottom: 1.5px dashed #000;
    margin-bottom: 1.2mm; letter-spacing: 0.5px;
  }
  .part-cont {
    text-align: center; font-size: 12px; font-weight: 800;
    padding: 2mm 0 3mm; margin-top: 1.5mm;
    border-top: 2px dashed #000;
    letter-spacing: 0.5px;
  }
  .ir-name {
    font-family: 'Arial Narrow', 'Arial', 'Helvetica', sans-serif;
    font-size: 13px; font-weight: 700; letter-spacing: -0.1px;
    word-break: break-word; white-space: normal;
    margin-bottom: 0.5mm; line-height: 1.1;
    -webkit-font-smoothing: antialiased;
  }
  .ir-disc { display: inline-block; font-size: 12px; font-weight: 700; color: #000; border: 1.5px solid #000; padding: 0.3mm 1.2mm; margin: 0.4mm 0; }
  .ir-alt { font-size: 12px; font-style: italic; color: #000; margin-bottom: 0.4mm; }

  .leader-line {
    display: flex; align-items: baseline;
    font-size: 13px; line-height: 1.25; gap: 1px; width: 100%;
  }
  .ll-left { white-space: nowrap; }
  .ll-right { white-space: nowrap; font-weight: 700; text-align: right; }
  .ll-dots {
    flex: 1 1 auto; min-width: 4mm; border-bottom: 2px dotted #000;
    align-self: center; height: 0; margin: 0 1.5mm;
  }
  .ll-jami {
    font-size: 16px; font-weight: 900;
    border-top: 2px solid #000; border-bottom: 2px solid #000;
    padding: 0.8mm 0; margin: 0.8mm 0;
  }
  .ll-italic .ll-left, .ll-italic .ll-right { font-style: italic; }
  .ll-bold .ll-left, .ll-bold .ll-right { font-weight: 900; }
  /* Chizilgan asl narx — qora yupqa chiziq, oddiy weight (asosiy matnga nisbatan farqlanadi) */
  .ll-strike .ll-left, .ll-strike .ll-right {
    text-decoration: line-through;
    text-decoration-color: #000;
    text-decoration-thickness: 1px;
    color: #000;
    font-weight: 500;
    font-style: italic;
  }
  .ll-strike .ll-dots { border-bottom-color: #000; border-bottom-style: dotted; }

  .calc-section { margin: 1.5mm 0; }
  /* Qaytarilgan mahsulotlar bo'limi (savdo + qaytarilgan rejimi) */
  .refund-section { margin-top: 2mm; padding-top: 1.5mm; border-top: 2px dashed #000; page-break-inside: avoid; }
  .refund-title { font-size: 14px; font-weight: 900; text-transform: uppercase; letter-spacing: 0.3px; margin-bottom: 1mm; }
  .refund-when { font-size: 11px; font-style: italic; margin-bottom: 0.8mm; word-break: break-word; }
  .refund-total-box { margin-top: 1.5mm; padding-top: 1mm; border-top: 1.5px dashed #000; }
  .debt-section { margin-top: 2mm; padding-top: 1.5mm; border-top: 1.5px dashed #000; }
  .debt-title { font-size: 14px; font-weight: 800; margin-bottom: 1mm; }
  .debt-comment-line { font-size: 12px; font-style: italic; margin-top: 1mm; word-break: break-word; }

  /* Qaytarilgan mahsulotlar bloki ("savdo + qaytarilgan" rejimi) */
  .refund-section { margin-top: 2mm; padding-top: 1.5mm; border-top: 2px dashed #000; page-break-inside: avoid; break-inside: avoid; }
  .refund-title { font-size: 14px; font-weight: 900; text-transform: uppercase; letter-spacing: 0.3px; margin-bottom: 1mm; }
  .refund-when { font-size: 11px; font-style: italic; margin: 0.5mm 0; }
  .refund-total-box { margin-top: 1.5mm; padding-top: 1mm; border-top: 1px dashed #000; }

  .receipt-footer { text-align: center; margin-top: 2mm; padding-bottom: 3mm; }
  .check-word { font-weight: 800; font-size: 13px; text-transform: uppercase; letter-spacing: 0.5px; }
  .thank-you { font-size: 12px; color: #000; margin-top: 1.5mm; font-weight: 600; }

  .receipt-barcode { text-align: center; margin-top: 2mm; padding-bottom: 3mm; }
  .receipt-barcode svg { width: 70mm; height: auto; max-height: 18mm; }
</style>
</head>
<body>
  <div class="receipt-header">
    ${logoHtml}
    <div class="firm-name">${s.firmName}</div>
    ${s.phone ? '<div class="firm-phone">Kontaktlar: ' + s.phone + '</div>' : ''}
    <div class="receipt-date">${date}</div>
  </div>
  <div class="receipt-divider"></div>
  <div class="receipt-info">
    <div class="info-row"><span class="info-label">Mijoz:</span><span class="info-value">${clientName}</span></div>
    ${masterHtml}
    ${carHtml}
  </div>
  ${splitN > 0 && rows.length > splitN
    ? itemsHtml
    : `<div class="items-section">${itemsHtml}</div>`}
  <div class="calc-section">
    <div class="leader-line"><span class="ll-left">Mahsulotlarning umumiy soni</span><span class="ll-dots"></span><span class="ll-right">${totalQty} birlik.</span></div>
    ${priceReductionHtml}
    ${oraliqHtml}
    <div class="leader-line ll-jami"><span class="ll-left">JAMI</span><span class="ll-dots"></span><span class="ll-right">${fmtUZS(totalSum)}</span></div>
    ${paidHtml}
  </div>
  ${refundHtml}
  ${debtHtml}
  <div class="receipt-divider"></div>
  <div class="receipt-footer">
    ${checkWordHtml}
  </div>
  ${barcodeHtml}
</body>
</html>`);
      printWindow.document.close();
      printWindow.focus();
      setTimeout(() => { printWindow.print(); printWindow.close(); }, 400);
    },
    editSale(item) {
      // Savdoni POS'da tahrirlash rejimida ochamiz (PATCH /service-sale/id/:id)
      this.$router.push('/chiqim/pos?edit=' + item.id);
    },
    async deleteItem() {
      try {
        await axios.delete(`api/v1/service-sale/id/${this.selectedItem.id}`);
        this.sales = this.sales.filter(s => s.id !== this.selectedItem.id);
        this.closeDeleteModal();
      } catch (e) {
        alert("O'chirishda xatolik yuz berdi");
      }
    },
    openPayModal(item) {
      this.payItem = item;
      this.payForm = { pay_type_id: 1, paid_summa: 0, comment: `Savdo #${item.id} uchun to'lov` };
      this.showPayModal = true;
    },
    closePayModal() {
      this.showPayModal = false;
      this.payItem = null;
    },
    openRefundModal(item) {
      this.refundItem = item;
      // Xizmatlar ro'yxatini tayyorlash
      this.refundServiceList = [];
      if (item.packages && item.packages.length > 0) {
        this.refundServiceList = item.packages.map(pkg => ({
          repair_package_id: pkg.repair_package_id,
          name: pkg.name || '-',
          labor_price_chakana: Number(pkg.labor_price_chakana || 0),
          redo_price_chakana: Number(pkg.redo_price_chakana || 0),
          labor_price_optom: Number(pkg.labor_price_optom || 0),
          redo_price_optom: Number(pkg.redo_price_optom || 0),
          total: Number(pkg.labor_price_chakana || 0) + Number(pkg.redo_price_chakana || 0) + Number(pkg.labor_price_optom || 0) + Number(pkg.redo_price_optom || 0),
          selected: false,
        }));
      } else if (item.repair_package) {
        const total = Number(item.labor_price_chakana || 0) + Number(item.redo_price_chakana || 0) + Number(item.labor_price_optom || 0) + Number(item.redo_price_optom || 0);
        if (total > 0) {
          this.refundServiceList = [{
            repair_package_id: item.repair_package_id || (item.repair_package && item.repair_package.id),
            name: item.repair_package.name,
            labor_price_chakana: Number(item.labor_price_chakana || 0),
            redo_price_chakana: Number(item.redo_price_chakana || 0),
            labor_price_optom: Number(item.labor_price_optom || 0),
            redo_price_optom: Number(item.redo_price_optom || 0),
            total,
            selected: false,
          }];
        }
      }
      // Mahsulotlar ro'yxatini tayyorlash
      this.refundProductList = [];
      if (item.items && item.items.length > 0) {
        this.refundProductList = item.items.map(itm => ({
          product_id: itm.product_id,
          name: itm.product ? (itm.product.name || itm.product.extra_name) : '-',
          max_count: Number(itm.count),
          refund_count: Number(itm.count),
          price: Number(itm.price),
          refund_summa: Number(itm.summa),
          selected: false,
        }));
      }
      const hasKontragent = !!item.kontragent_id;
      const amounts = {};
      (this.payTypes || []).forEach(pt => { amounts[pt.id] = 0; });
      this.refundForm = {
        payMode: hasKontragent ? 'debt' : 'cash',
        payAmounts: amounts,
        dollarRate: Number(item.dollar_rate || this.refundForm.dollarRate || 12500),
        comment: '',
      };
      this.showRefundModal = true;
    },
    // Refund cash rejim: barcha pay_type 0, birinchi so'mli turga refundGrandTotal
    refundDefaultFillCash() {
      const types = this.payTypes || [];
      const firstSum = types.find(pt => !this.isDollarPayType(pt)) || types[0];
      types.forEach(pt => { this.$set(this.refundForm.payAmounts, pt.id, 0); });
      if (firstSum) this.$set(this.refundForm.payAmounts, firstSum.id, this.refundGrandTotal || 0);
    },
    // ⚡ Tanlangan to'lov turiga qolgan summani to'ldirish
    refundFillPayTypeRemaining(pt) {
      const others = (this.payTypes || []).reduce((sum, p) => {
        if (p.id === pt.id) return sum;
        const amt = Number(this.refundForm.payAmounts[p.id] || 0);
        return sum + (this.isDollarPayType(p) ? amt * Number(this.refundForm.dollarRate || 0) : amt);
      }, 0);
      const remainingSum = Math.max(0, this.refundGrandTotal - others);
      const val = this.isDollarPayType(pt)
        ? Number((remainingSum / Number(this.refundForm.dollarRate || 1)).toFixed(2))
        : remainingSum;
      this.$set(this.refundForm.payAmounts, pt.id, val);
    },
    closeRefundModal() {
      this.showRefundModal = false;
      this.refundItem = null;
      this.refundProductList = [];
      this.refundServiceList = [];
    },
    recalcProductSumma(prod) {
      if (prod.refund_count > prod.max_count) prod.refund_count = prod.max_count;
      if (prod.refund_count < 0) prod.refund_count = 0;
      prod.refund_summa = prod.refund_count * prod.price;
    },
    async submitRefund() {
      if (!this.canSubmitRefund || !this.refundItem) return;
      this.refundLoading = true;
      try {
        const refund_items = this.refundProductList
          .filter(p => p.selected && p.refund_count > 0)
          .map(p => ({ product_id: p.product_id, count: p.refund_count, price: p.price, summa: p.refund_summa }));
        const refund_services = this.refundServiceList
          .filter(s => s.selected)
          .map(s => ({
            repair_package_id: s.repair_package_id,
            labor_price_chakana: s.labor_price_chakana,
            redo_price_chakana: s.redo_price_chakana,
            labor_price_optom: s.labor_price_optom,
            redo_price_optom: s.redo_price_optom,
          }));

        // DINAMIK to'lov turlari — faqat cash rejimida
        const payments = this.refundForm.payMode === 'cash'
          ? (this.payTypes || [])
              .map(pt => ({
                pay_type_id: pt.id,
                summa: Number(this.refundForm.payAmounts[pt.id] || 0),
                dollar_rate: this.isDollarPayType(pt) ? Number(this.refundForm.dollarRate || 1) : 1,
              }))
              .filter(p => p.summa > 0)
          : [];

        const defaultComment = this.refundForm.payMode === 'debt'
          ? 'Qaytarish (qarzdan ushlash)'
          : 'Qaytarish (kassadan to\'lov turlari bo\'yicha)';

        await axios.post(`api/v1/service-sale/id/${this.refundItem.id}/refund`, {
          refund_items,
          refund_services,
          payments,
          paid_summa: this.refundForm.payMode === 'cash' ? this.refundGrandTotal : 0,
          pay_type_id: payments[0] ? payments[0].pay_type_id : 1,
          comment: this.refundForm.comment || defaultComment,
        });
        this.closeRefundModal();
        this.fetchSales();
      } catch (e) {
        console.error('Qaytarish xatosi:', e);
        alert("Qaytarishda xatolik yuz berdi");
      } finally {
        this.refundLoading = false;
      }
    },
    async submitPayment() {
      if (this.payFormTotal <= 0 || !this.payItem) return;
      this.payLoading = true;
      try {
        await axios.patch(`api/v1/service-sale/id/${this.payItem.id}/pay`, {
          paid_summa: Number(this.payForm.paid_summa || 0),
          pay_type_id: Number(this.payForm.pay_type_id || 1),
          comment: this.payForm.comment || '',
        });

        this.closePayModal();
        this.fetchSales();
      } catch (e) {
        console.error('To\'lov xatosi:', e);
        alert("To'lovda xatolik yuz berdi");
      } finally {
        this.payLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-container {
  max-width: 1600px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 24px;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.date-input {
  height: 40px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  padding: 0 12px;
  font-weight: 600;
  color: #475569;
  outline: none;
  background: white;
}

.master-select {
  height: 40px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  padding: 0 12px;
  font-weight: 600;
  color: #475569;
  outline: none;
  background: white;
  min-width: 160px;
}

/* YANGILASH TUGMASI + auto-polling indikator */
.refresh-sales-btn {
  position: relative;
  background: white;
  border: 1px solid #e2e8f0;
  color: #2563eb;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: 0.2s;
}

.refresh-sales-btn:hover {
  background: #eff6ff;
  border-color: #2563eb;
  transform: rotate(45deg);
}

.refresh-sales-btn .new-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #ef4444;
  color: white;
  font-size: 10px;
  font-weight: 800;
  padding: 2px 6px;
  border-radius: 999px;
  min-width: 18px;
  text-align: center;
  box-shadow: 0 2px 6px rgba(239,68,68,0.4);
  animation: pulse 1.4s infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50%      { transform: scale(1.15); }
}

.refresh-sales-btn .auto-dot {
  position: absolute;
  bottom: 4px;
  right: 4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 6px rgba(34,197,94,0.6);
  animation: blink 2s infinite;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50%      { opacity: 0.4; }
}

.print-split-select {
  height: 40px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  padding: 0 12px;
  font-weight: 600;
  color: #2563eb;
  outline: none;
  background: #eff6ff;
  cursor: pointer;
  font-size: 13px;
  min-width: 200px;
  transition: 0.2s;
}

.print-split-select:hover {
  background: #dbeafe;
  border-color: #2563eb;
}

.print-split-select:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37,99,235,0.1);
}

.add-btn {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border: none;
  height: 40px;
  padding: 0 18px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(161, 66, 244, 0.3);
}

.table-card {
  background: white;
  border-radius: 20px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-wrapper {
  overflow-y: auto;
  flex-grow: 1;
}

.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 5;
  padding: 14px 10px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f5f9;
}

.custom-table td {
  padding: 11px 10px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 14px;
}

.total-row td {
  padding: 12px 10px;
  background: #f8fafc;
  border-top: 2px solid #e2e8f0;
  font-size: 14px;
}

.id-badge {
  background: #f1f5f9;
  padding: 3px 8px;
  border-radius: 7px;
  font-weight: 700;
  color: #64748b;
  font-size: 12px;
}

.price { font-weight: 700; }
.blue   { color: #2563eb; }
.green  { color: #10b981; }
.red    { color: #e11d48; }
.orange { color: #d97706; }

.tag {
  padding: 3px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
}

.blue-tag { background: #eff6ff; color: #2563eb; }

/* TOIFA badge — savdo turi indikatori */
.cat-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  cursor: help;
  white-space: nowrap;
}

.cat-pct {
  font-size: 10px;
  font-weight: 700;
  opacity: 0.85;
}

/* PAY BREAKDOWN PILLS */
.pay-breakdown-cell { min-width: 140px; }

.pay-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  margin-bottom: 3px;
}

.pay-pill {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 2px 7px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 800;
  white-space: nowrap;
  cursor: help;
  font-family: 'Inter', system-ui, sans-serif;
}

.pp-naqd    { background: #dcfce7; color: #15803d; }
.pp-plastic { background: #dbeafe; color: #1d4ed8; }
.pp-shot    { background: #fef3c7; color: #b45309; }
.pp-dollar  { background: #f0fdf4; color: #15803d; border: 1px solid #16a34a; }
.pp-other   { background: #f1f5f9; color: #475569; }

.pay-total {
  font-size: 12px;
  font-weight: 700;
}

.cat-premium  { background: #ede9fe; color: #6d28d9; }   /* Qimmat (ustama) */
.cat-full     { background: #dcfce7; color: #15803d; }   /* To'liq narx */
.cat-small    { background: #f1f5f9; color: #475569; }   /* Mayda chegirma */
.cat-discount { background: #fef3c7; color: #b45309; }   /* O'rta chegirma */
.cat-cheap    { background: #fee2e2; color: #b91c1c; }   /* Arzon */
.cat-unknown  { background: #f8fafc; color: #94a3b8; }

.actions { display: flex; gap: 6px; justify-content: center; }

.barcode-cell { text-align: center; padding: 4px 6px; cursor: default; }
.barcode-cell >>> svg { width: 160px; height: auto; max-height: 44px; display: inline-block; }

.icon-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.edit  { background: #eff6ff; color: #2563eb; }
.print { background: #f0fdf4; color: #10b981; }
.del   { background: #fff1f2; color: #e11d48; }
.pay   { background: #fef3c7; color: #d97706; }

.clickable-row { cursor: pointer; transition: background 0.15s; }
.clickable-row:hover { background: #f8fafc; }

.modal-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(15,23,42,0.3);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-box {
  background: white;
  padding: 35px;
  border-radius: 28px;
  width: 420px;
  text-align: center;
  box-shadow: 0 20px 50px rgba(0,0,0,0.1);
}

.warning-icon {
  width: 60px; height: 60px;
  background: #fee2e2; color: #ef4444;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 30px; font-weight: bold;
  margin: 0 auto 20px;
}

.modal-btns { display: flex; gap: 12px; margin-top: 25px; }

/* Chek rejimini tanlash tugmalari */
.print-choice-btns { display: flex; flex-direction: column; gap: 10px; margin-top: 20px; }
.m-btn.choice {
  display: flex; flex-direction: column; align-items: center; gap: 2px;
  background: #f8fafc; color: #1e293b; border: 2px solid #e2e8f0; font-size: 15px;
}
.m-btn.choice small { font-weight: 500; font-size: 11px; color: #64748b; }
.m-btn.choice:hover { border-color: #a142f4; background: #faf5ff; }
.m-btn.choice.primary { background: #f5f3ff; border-color: #a142f4; color: #6b21a8; }

.m-btn {
  flex: 1;
  padding: 13px;
  border-radius: 14px;
  border: none;
  font-weight: 700;
  cursor: pointer;
}

.cancel  { background: #f1f5f9; color: #64748b; }
.confirm { background: #e11d48; color: white; }

.animate-pop {
  animation: pop 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes pop {
  0%   { transform: scale(0.9); opacity: 0; }
  100% { transform: scale(1);   opacity: 1; }
}

/* DETAIL MODAL */
.detail-modal {
  background: white;
  padding: 0;
  border-radius: 24px;
  width: 620px;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 20px 50px rgba(0,0,0,0.12);
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  border-bottom: 1px solid #f1f5f9;
}

.detail-header h3 {
  margin: 0;
  font-size: 18px;
  color: #1e293b;
}

.close-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: none;
  background: #f1f5f9;
  font-size: 22px;
  cursor: pointer;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover { background: #e2e8f0; }

.detail-info {
  padding: 16px 25px;
  background: #f8fafc;
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.info-row {
  font-size: 13px;
  color: #475569;
}

.info-label {
  color: #94a3b8;
  margin-right: 4px;
}

.detail-section {
  padding: 16px 25px 8px;
}

.section-title {
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  margin: 0 0 10px;
}

.section-title.purple { color: #a142f4; }
.section-title.blue { color: #2563eb; }

.detail-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.detail-table th {
  padding: 8px 10px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  text-align: left;
  border-bottom: 1px solid #f1f5f9;
}

.detail-table td {
  padding: 8px 10px;
  border-bottom: 1px solid #f8fafc;
  color: #334155;
}

.detail-table .total-row td {
  border-top: 2px solid #e2e8f0;
  padding-top: 10px;
}

.purple { color: #a142f4; }

.detail-footer {
  padding: 16px 25px 20px;
  border-top: 1px solid #f1f5f9;
  margin-top: 8px;
}

.footer-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  font-size: 14px;
  color: #475569;
}

.footer-row.total {
  padding-top: 10px;
  margin-top: 6px;
  border-top: 2px solid #e2e8f0;
  font-size: 16px;
}

.empty-detail {
  padding: 30px;
  text-align: center;
  color: #94a3b8;
}

/* TO'LOV MODALI */
.pay-modal {
  background: white;
  border-radius: 24px;
  width: 480px;
  box-shadow: 0 20px 50px rgba(0,0,0,0.12);
}

.pay-info {
  padding: 16px 25px;
  background: #f8fafc;
}

.pay-info-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  font-size: 14px;
}

.pay-form {
  padding: 20px 25px;
}

.pay-field {
  margin-bottom: 12px;
}

.pay-field label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.pay-input {
  width: 100%;
  height: 40px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 12px;
  font-size: 14px;
  font-weight: 600;
  outline: none;
}

.pay-input:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161,66,244,0.1);
}

.pay-total-row {
  display: flex;
  justify-content: space-between;
  padding: 12px 0 0;
  margin-top: 8px;
  border-top: 2px solid #e2e8f0;
  font-size: 16px;
}

.pay-actions {
  display: flex;
  gap: 12px;
  padding: 0 25px 20px;
}

.pay-confirm {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
}

.pay-confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* REFUND MODAL */
.refund-btn { background: #fef3c7; color: #d97706; }

.refund-modal {
  background: white;
  border-radius: 24px;
  width: 600px;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 20px 50px rgba(0,0,0,0.12);
}

.refund-section {
  padding: 16px 25px 8px;
}

.refund-check-row {
  padding: 6px 0;
  border-bottom: 1px solid #f8fafc;
}

.refund-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 14px;
}

.refund-checkbox input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #a142f4;
  cursor: pointer;
}

.refund-item-name {
  flex: 1;
  color: #334155;
  font-weight: 600;
}

.refund-item-price {
  font-weight: 700;
  color: #a142f4;
}

.refund-count-input {
  width: 64px;
  height: 30px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0 6px;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  outline: none;
}

.refund-count-input:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 2px rgba(161,66,244,0.1);
}

.refund-count-input:disabled {
  background: #f1f5f9;
  color: #94a3b8;
}

.refund-summary {
  padding: 12px 25px;
  background: #f8fafc;
}

.refund-confirm {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;
  color: white !important;
}

.refund-confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ============ ARZON SOTILGAN MAHSULOT (asl narx chizilgan) ============ */
.detail-table .arzon-row { background: linear-gradient(to right, #fef3c7 0%, transparent 100%); }
.orig-strike {
  display: block;
  font-size: 11px;
  color: #94a3b8;
  text-decoration: line-through;
  margin-bottom: 2px;
}
.disc-pill {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 7px;
  background: #fff7ed;
  color: #c2410c;
  border: 1px dashed #fb923c;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  vertical-align: middle;
}

/* ============ TO'LOV MA'LUMOTLARI (mobile chek formati) ============ */
.pay-info-card { background: #f8fafc; border-radius: 12px; padding: 16px; margin-top: 12px; }
.pay-info-card .section-title { margin-bottom: 12px; }
.pi-row {
  display: flex; justify-content: space-between; align-items: center;
  padding: 6px 0; font-size: 14px;
}
.pi-label { color: #64748b; font-weight: 500; }
.pi-val { font-weight: 600; color: #1e293b; }
.pi-jami { padding: 10px 0; }
.pi-jami .pi-label { font-size: 16px; font-weight: 700; color: #1e293b; }
.pi-jami-val { font-size: 18px; font-weight: 800; color: #1e293b; }
.pi-orig-strike {
  color: #94a3b8;
  text-decoration: line-through;
  font-weight: 500;
}
.pi-divider { border-top: 1px solid #e2e8f0; margin: 8px 0; }
.pi-pay { padding: 8px 0; }
.pi-pay .pi-label { display: flex; align-items: center; gap: 8px; color: #334155; font-weight: 600; }
.pi-icon {
  display: inline-flex; align-items: center; justify-content: center;
  width: 26px; height: 26px; border-radius: 50%;
  font-size: 14px; font-weight: 800;
}
.pi-icon.cur-dollar { background: #dcfce7; color: #15803d; }
.pi-icon.cur-sum    { background: #dbeafe; color: #1e40af; }
.pi-paid { color: #15803d; font-weight: 700; }
.pi-sum-eq { color: #94a3b8; font-weight: 500; font-size: 12px; margin-left: 4px; }
.pi-debt .pi-label { color: #b91c1c; }
.pi-debt-val { color: #b91c1c; font-weight: 800; font-size: 15px; }
.pi-due .pi-label, .pi-due .pi-val { color: #ca8a04; }
.pi-comment .pi-val { font-style: italic; max-width: 60%; text-align: right; }

/* ═════════════ 🔄 MAHSULOT QAYTARISH MODAL ═════════════ */
.refund-add-btn {
  background: linear-gradient(135deg, #f97316, #ea580c) !important;
  box-shadow: 0 4px 14px rgba(249, 115, 22, 0.35) !important;
}
.refund-add-btn:hover { opacity: 0.92; }

.pr-overlay {
  position: fixed; inset: 0;
  background: rgba(15,23,42,0.5);
  z-index: 9999;
  display: flex; align-items: center; justify-content: center;
  backdrop-filter: blur(3px);
}
.pr-modal {
  background: white; border-radius: 20px;
  width: 800px; max-width: 96vw; max-height: 92vh;
  display: flex; flex-direction: column; overflow: hidden;
  box-shadow: 0 24px 64px rgba(0,0,0,0.18);
}
.pr-head {
  padding: 18px 22px; border-bottom: 1px solid #f1f5f9;
  display: flex; justify-content: space-between; align-items: center;
  background: linear-gradient(135deg, #fff7ed, #ffedd5);
}
.pr-title { margin: 0; font-size: 18px; font-weight: 800; color: #9a3412; }
.pr-close {
  background: white; border: none;
  width: 34px; height: 34px; border-radius: 50%;
  font-size: 22px; cursor: pointer; color: #64748b;
}
.pr-body { padding: 18px 22px; overflow-y: auto; flex: 1; display: flex; flex-direction: column; gap: 14px; }
/* Bolalar siqilmasin — aks holda overflow:hidden bloklar (xaridlar ro'yxati) kesiladi */
.pr-body > * { flex-shrink: 0; }
.pr-foot {
  padding: 14px 22px; border-top: 1px solid #f1f5f9;
  display: flex; gap: 10px; justify-content: flex-end;
}
.pr-field { display: flex; flex-direction: column; gap: 6px; position: relative; }
.pr-label { font-size: 12px; font-weight: 700; color: #64748b; text-transform: uppercase; }
.pr-restock { margin: 4px 0 10px; }
.pr-restock-toggle { display: flex; align-items: flex-start; gap: 10px; cursor: pointer; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 10px; padding: 10px 12px; }
.pr-restock-toggle input { margin-top: 3px; width: 18px; height: 18px; cursor: pointer; flex-shrink: 0; }
.pr-restock-text { display: flex; flex-direction: column; gap: 2px; font-size: 13px; color: #334155; }
.pr-restock-text small { font-size: 11px; color: #94a3b8; }
.pr-req { color: #ef4444; }
.pr-input {
  height: 42px; border: 1.5px solid #e2e8f0; border-radius: 10px;
  padding: 0 14px; font-size: 14px; font-weight: 600; outline: none;
  transition: 0.15s;
}
.pr-input:focus { border-color: #f97316; box-shadow: 0 0 0 3px rgba(249,115,22,0.1); }

.pr-dropdown {
  position: absolute; top: 100%; left: 0; right: 0;
  background: white; border: 1px solid #e2e8f0; border-radius: 10px;
  margin-top: 4px; max-height: 280px; overflow-y: auto;
  box-shadow: 0 8px 24px rgba(0,0,0,0.08);
  z-index: 10;
}
.pr-dd-item {
  padding: 10px 12px; cursor: pointer;
  border-bottom: 1px solid #f1f5f9;
  display: grid; grid-template-columns: 2fr 1fr 1fr; gap: 8px; align-items: center;
}
.pr-dd-item:hover { background: #fff7ed; }
.pr-dd-item:last-child { border-bottom: none; }
.pr-dd-name { font-weight: 700; color: #1e293b; font-size: 13px; }
.pr-dd-phone { font-size: 12px; color: #64748b; }
.pr-dd-info { font-size: 12px; color: #475569; }
.pr-dd-debt { font-size: 12px; text-align: right; }
.pr-dd-debt.debt-red { color: #b91c1c; font-weight: 700; }
.pr-dd-debt.debt-gray { color: #94a3b8; }
.pr-code {
  background: #ede9fe; color: #5850ec;
  font-family: 'JetBrains Mono', monospace; font-weight: 700;
  font-size: 10px; padding: 2px 5px; border-radius: 4px;
  margin-left: 6px;
}

.pr-selected {
  display: flex; align-items: center; gap: 12px;
  background: #ecfdf5; border: 1px solid #86efac;
  padding: 10px 14px; border-radius: 10px;
  color: #166534; font-size: 13px;
}
.pr-debt-info { margin-left: auto; color: #b91c1c; font-weight: 700; }
.pr-debt-info.no-debt { color: #94a3b8; font-weight: 600; }
.pr-clear-btn {
  background: #fff1f2; color: #e11d48; border: none;
  width: 26px; height: 26px; border-radius: 6px;
  cursor: pointer; font-weight: 700;
}

.pr-empty {
  text-align: center; padding: 30px 20px;
  color: #94a3b8; font-weight: 600;
  background: #f8fafc; border-radius: 10px;
}

/* v-select — toza, zamonaviy ko'rinish */
.pr-vselect { font-size: 14px; }
.pr-vselect .vs__dropdown-toggle {
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  height: 44px;
  padding: 0 6px 0 12px;
  background: #fff;
  align-items: center;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.pr-vselect:hover .vs__dropdown-toggle { border-color: #cbd5e1; }
.pr-vselect.vs--open .vs__dropdown-toggle {
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249,115,22,0.12);
}
.pr-vselect .vs__selected-options { padding: 0; flex-wrap: nowrap; overflow: hidden; }
.pr-vselect .vs__selected {
  margin: 0; padding: 0;
  font-size: 14px; font-weight: 600; color: #1e293b;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.pr-vselect .vs__search,
.pr-vselect .vs__search:focus {
  margin: 0; padding: 0; font-size: 14px; line-height: 44px; color: #1e293b;
}
.pr-vselect .vs__search::placeholder { color: #94a3b8; font-weight: 500; }
.pr-vselect .vs__actions { padding: 0 4px; gap: 2px; }
.pr-vselect .vs__clear { display: flex; align-items: center; }
.pr-vselect .vs__clear svg { fill: #94a3b8; transition: fill 0.15s; }
.pr-vselect .vs__clear:hover svg { fill: #ef4444; }
.pr-vselect .vs__open-indicator { fill: #94a3b8; }
.pr-vselect .vs__dropdown-menu {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(15,23,42,0.12);
  max-height: 300px;
  padding: 6px;
  margin-top: 6px;
}
.pr-vselect .vs__dropdown-option {
  padding: 9px 12px;
  border-radius: 8px;
  color: #334155;
  font-size: 13px;
}
.pr-vselect .vs__dropdown-option--highlight {
  background: #fff7ed;
  color: #9a3412;
}
.pr-vselect .vs__no-options { padding: 14px; color: #94a3b8; font-size: 13px; }
.pr-opt-row { display: flex; justify-content: space-between; align-items: center; gap: 10px; }
.pr-opt-phone { font-size: 11px; color: #94a3b8; margin-left: 8px; }
.pr-opt-info { font-size: 12px; color: #475569; }
.pr-opt-debt { font-size: 12px; font-weight: 700; white-space: nowrap; }
.pr-opt-debt.debt-red { color: #b91c1c; }
.pr-opt-debt.debt-green { color: #15803d; }
.pr-opt-debt.debt-gray { color: #94a3b8; font-weight: 500; }

.pr-opt-tag {
  font-size: 10px; font-weight: 600;
  color: #94a3b8; text-transform: lowercase;
  margin-left: 4px;
}

/* Kompakt qarz qatori */
.pr-debt-line { margin-top: 6px; font-size: 13px; color: #334155; }
.pr-debt-line b { color: #1e293b; }
.pr-debt-line.muted { color: #94a3b8; }

/* Mijoz sotib olgan mahsulotlar bloki */
.pr-purchased {
  margin: 6px 0 2px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
}
.pr-purchased-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 8px 12px;
  font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.3px;
  color: #64748b;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}
.pr-purchased-loading { font-size: 11px; color: #94a3b8; font-style: italic; text-transform: none; }
.pr-purchased-count { font-size: 11px; color: #94a3b8; font-weight: 600; }
.pr-purchased-empty { padding: 14px; font-size: 13px; color: #94a3b8; text-align: center; }
.pr-purchased-list { max-height: 200px; overflow-y: auto; }
.pr-purchased-row {
  display: flex; align-items: center; justify-content: space-between;
  gap: 10px; padding: 8px 12px;
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.15s;
}
.pr-purchased-row:last-child { border-bottom: none; }
.pr-purchased-row.picked { background: #f0f7ff; }
.pr-purchased-info { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.pr-purchased-name { font-weight: 600; color: #1e293b; font-size: 13px; }
.pr-purchased-meta { font-size: 12px; color: #94a3b8; }

/* +/− stepper */
.pr-stepper {
  flex-shrink: 0;
  display: inline-flex; align-items: center; gap: 2px;
  border: 1px solid #e2e8f0; border-radius: 8px; overflow: hidden;
  background: #fff;
}
.pr-step-btn {
  width: 30px; height: 30px; border: none; background: #f8fafc;
  color: #334155; font-size: 18px; font-weight: 700; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: background 0.15s;
}
.pr-step-btn:hover:not(:disabled) { background: #e2e8f0; }
.pr-step-btn:disabled { color: #cbd5e1; cursor: default; }
.pr-step-val { min-width: 30px; text-align: center; font-size: 14px; font-weight: 700; color: #1e293b; }

/* "Boshqa mahsulot qo'shish" sarlavhasi */
.pr-add-other-hint {
  margin: 10px 0 2px;
  font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.3px;
  color: #64748b;
}

/* 2 ustunli row (qidiruv + skaner) */
.pr-row-2 { display: flex; gap: 12px; }
.pr-scanner-input {
  background: #f8fafc;
  border: 1.5px solid #e2e8f0;
  font-family: 'JetBrains Mono', 'Consolas', monospace;
  font-weight: 700;
  letter-spacing: 0.5px;
}
.pr-scanner-input:focus { border-color: #f97316; box-shadow: 0 0 0 3px rgba(249,115,22,0.1); }

/* To'lov rejimi radio kartlari */
.pr-paymode { display: flex; flex-direction: column; gap: 6px; }
.pr-paymode-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.pr-radio-card {
  display: flex; align-items: flex-start; gap: 10px;
  padding: 12px 14px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  cursor: pointer;
  background: white;
  transition: 0.15s;
}
.pr-radio-card:hover { border-color: #fdba74; background: #fffbeb; }
.pr-radio-card.active {
  border-color: #f97316;
  background: #fff7ed;
  box-shadow: 0 4px 12px rgba(249,115,22,0.15);
}
.pr-radio-card input[type="radio"] {
  margin-top: 3px;
  width: 18px; height: 18px;
  accent-color: #f97316;
  flex-shrink: 0;
}
.pr-radio-body { flex: 1; }
.pr-radio-title {
  font-weight: 800; color: #1e293b; font-size: 14px;
  margin-bottom: 4px;
}
.pr-radio-desc {
  font-size: 12px; color: #64748b; line-height: 1.4;
}
.pr-radio-warn {
  display: block; margin-top: 4px;
  color: #b45309; font-weight: 600;
}

@media (max-width: 600px) {
  .pr-paymode-grid { grid-template-columns: 1fr; }
}

/* To'lov turlari (cash mode) */
.pr-paytypes {
  margin-top: 10px;
  padding: 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  display: flex; flex-direction: column; gap: 8px;
}
.pr-paytypes-title {
  font-size: 13px; font-weight: 700; color: #475569;
  margin-bottom: 4px;
}
.pr-paytypes-title b { color: #1e293b; font-size: 14px; }
.pr-paytype-row {
  display: flex; align-items: center; gap: 8px;
}
.pr-paytype-label {
  flex: 0 0 130px;
  font-size: 13px; font-weight: 700; color: #475569;
}
.pr-paytype-input {
  flex: 1;
  height: 38px !important;
  text-align: right;
  font-weight: 700;
}
.pr-quick-fill {
  background: #f1f5f9; color: #475569;
  border: 1px solid #e2e8f0; border-radius: 8px;
  width: 36px; height: 38px;
  font-size: 15px; cursor: pointer;
  transition: 0.15s;
}
.pr-quick-fill:hover { background: #e2e8f0; }
.pr-dollar-eq {
  font-size: 11px; color: #64748b; font-weight: 600;
  margin-left: 8px;
}
.pr-paytypes-summary {
  margin-top: 6px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 13px;
}
.pr-paytypes-summary.ok    { background: #f0fdf4; border: 1px solid #86efac; color: #14532d; }
.pr-paytypes-summary.over  { background: #fff7ed; border: 1px solid #fdba74; color: #9a3412; }
.pr-paytypes-summary.under { background: #fef2f2; border: 1px solid #fca5a5; color: #991b1b; }
.pr-pts-row {
  display: flex; justify-content: space-between;
  padding: 2px 0;
}
.pr-pts-diff {
  border-top: 1px dashed currentColor;
  padding-top: 4px; margin-top: 4px;
  font-weight: 800;
}

.pr-table { width: 100%; border-collapse: collapse; }
.pr-table th {
  background: #f8fafc; padding: 8px;
  font-size: 11px; font-weight: 800; color: #64748b;
  text-transform: uppercase; text-align: left;
  border-bottom: 1.5px solid #e8edf3;
}
.pr-table td { padding: 8px; border-bottom: 1px solid #f1f5f9; font-size: 13px; }
.pr-pname { font-weight: 700; color: #1e293b; }
.pr-maxhint { display: block; font-size: 11px; color: #94a3b8; font-weight: 600; }
.pr-qty {
  width: 80px; height: 30px;
  border: 1.5px solid #e2e8f0; border-radius: 7px;
  padding: 0 8px; font-size: 13px; font-weight: 700;
  text-align: center; outline: none;
}
.pr-qty:focus { border-color: #f97316; }
.pr-summa { font-weight: 700; color: #5850ec; text-align: right; }
.pr-btn-x {
  background: #fff1f2; color: #e11d48; border: none;
  width: 28px; height: 28px; border-radius: 7px; cursor: pointer;
}
.pr-btn-x:hover { background: #e11d48; color: white; }
.pr-jami-label { text-align: right; font-weight: 800; padding: 12px 8px !important; background: #f1f5f9 !important; }
.pr-jami-val { font-size: 16px; font-weight: 900; color: #f97316; padding: 12px 8px !important; background: #f1f5f9 !important; }

.pr-btn-cancel {
  background: #f1f5f9; color: #64748b; border: none;
  height: 42px; padding: 0 20px; border-radius: 10px;
  font-weight: 700; cursor: pointer;
}
.pr-btn-save {
  background: linear-gradient(135deg, #f97316, #ea580c);
  color: white; border: none;
  height: 42px; padding: 0 22px; border-radius: 10px;
  font-weight: 800; cursor: pointer;
  display: flex; align-items: center; gap: 8px;
  box-shadow: 0 4px 14px rgba(249,115,22,0.35);
}
.pr-btn-save:hover:not(:disabled) { opacity: 0.92; }
.pr-btn-save:disabled { opacity: 0.4; cursor: not-allowed; }
</style>
